'use strict';

var teamsports = angular.module('gymsystem.teamsports', []);

teamsports.controller('TeamSportsListCtrl', ['$rootScope', '$scope', 'live', '$timeout', '$filter', '$modal', 'formatter', 'server', 'confirm', '$location', function($rootScope, $scope, live, $timeout, $filter, $modal, formatter, server, confirm, $location) {

    $scope.config = {
        api: {
            url: '/api/teamsport/get',
            triggers: [ {type: 'teamsport'}]
        },
        countSuffixList: ['team sport', 'team sports'],
        giveFocus: function() {
            return false;
        },
        rowClick: function(ts) {
            $location.path('/teamsport/' + ts.id);
        },
        columns: [
            {field: 'image', title: '', src: function(ts) {return $rootScope.image('teamsport', ts, 50); }},
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name'
    };
}]);

teamsports.controller('TeamSportsSettingsCtrl', ['$rootScope', '$scope', 'live', '$timeout', '$filter', 'util', function($rootScope, $scope, live, $timeout, $filter, util) {
    $scope.add = function() {
        util.showDataDialog({controller: 'TeamSportDataCtrl' });
    };

    $scope.change = function(teamsport) {
        util.showDataDialog({controller: 'TeamSportDataCtrl', item: teamsport });
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/get',
            triggers: [ {type: 'teamsport'}]
        },
        countSuffixList: ['team sport', 'team sports'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'image', title: '', src: function(ts) {return $rootScope.image('teamsport', ts, 50); }},
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);

teamsports.controller('TeamSportEventTypesListCtrl', ['$rootScope', '$scope', 'live', '$timeout', '$filter', '$modal', function($rootScope, $scope, live, $timeout, $filter, $modal) {
    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/teamsporteventtypeadd.html',
            controller: 'TeamSportEventTypeAddCtrl'
        });
    };

    $scope.change = function(teamsporteventtype) {
        $modal.open({
            templateUrl: 'views/teamsporteventtypeadd.html',
            controller: 'TeamSportEventTypeChangeCtrl',
            resolve: {
                teamsporteventtype: function() {
                    return teamsporteventtype;
                }
            }
        });
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/eventtype/get',
            triggers: [ {type: 'teamsporteventtype'}]
        },
        countSuffixList: ['event type', 'event types'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);

teamsports.controller('TeamSportTopListsListCtrl', ['$rootScope', '$scope', 'live', '$timeout', '$filter', '$modal', function($rootScope, $scope, live, $timeout, $filter, $modal) {
    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamSportTopListAddCtrl'
        });
    };

    $scope.change = function(teamsporttoplist) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamSportTopListChangeCtrl',
            resolve: {
                teamsporttoplist: function() {
                    return teamsporttoplist;
                }
            }
        });
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/toplist/get',
            triggers: [ {type: 'teamsporttoplist'}]
        },
        countSuffixList: ['top list', 'top lists'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);

teamsports.controller('TeamSportTableListCtrl', ['$rootScope', '$scope', 'util', function($rootScope, $scope, util) {
    $scope.add = function() {
        util.showDataDialog({controller: 'TeamSportTableDataCtrl'});
    };

    $scope.change = function(table) {
        util.showDataDialog({controller: 'TeamSportTableDataCtrl', item: table});
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/table/get',
            triggers: [ {type: 'teamsporttable'}]
        },
        countSuffixList: ['table', 'tables'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);

teamsports.controller('TeamSportScoringListCtrl', ['$rootScope', '$scope', 'util', function($rootScope, $scope, util) {
    $scope.add = function() {
        util.showDataDialog({controller: 'TeamSportScoringDataCtrl'});
    };

    $scope.change = function(scoring) {
        util.showDataDialog({controller: 'TeamSportScoringDataCtrl', item: scoring});
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/scoring/get',
            triggers: [ {type: 'teamsportscoring'}]
        },
        countSuffixList: ['scoring type', 'scoring types'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);


teamsports.controller('TeamSportResultInvalidTypeDataCtrl', ['$scope', 'server', 'teamsportutil', 'options', function($scope, server, teamsportutil, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'invalid result type',
        url: {
            add: '/api/teamsport/resultinvalid/add',
            change: '/api/teamsport/resultinvalid/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'result_diff', title: 'Result difference', type: 'number', required: false, min: -10000, max: 0 }
                ]
            }
        ]
    });
}]);

teamsports.controller('TeamSportResultInvalidTypeListCtrl', ['$rootScope', '$scope', 'util', function($rootScope, $scope, util) {
    $scope.add = function() {
        util.showDataDialog({controller: 'TeamSportResultInvalidTypeDataCtrl'});
    };

    $scope.change = function(type) {
        util.showDataDialog({controller: 'TeamSportResultInvalidTypeDataCtrl', item: type});
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/resultinvalid/get',
            triggers: [ {type: 'teamsportresultinvalidtype'}]
        },
        countSuffixList: ['invalid result type', 'invalid result types'],
        giveFocus: function() {
            return false;
        },
        rowClick: $scope.change,
        columns: [
            {field: 'name', title: 'Name' }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: $scope.add}
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.change }
        ]
    };
}]);

teamsports.controller('CompetitionStepTransitionRuleDataCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'teamsportutil', 'util', 'options', function($rootScope, $scope, $filter, $modal, server, teamsportutil, util, options) {

    function fetchDivisions() {
        var from = $scope.config.control.getField('from_competitionstep_id').value;
        if (from) {
            server.get('/api/teamsport/division/get', {competitionstep_id: from.id }).then(function(result) {
                $scope.config.data.fromdivisions = result;
            });
        }
    }

    function ruleType() {
        var f = $scope.config && $scope.config.control && $scope.config.control.getField('rule_type');
        return (f && util.getValueForField(f)) || 'bracket';
    }

    function hasRule() {
        var rules = $scope.config.data.rules;
        var type = ruleType();
        return !!_.find(rules, function(tr) {
            if($scope.config.item && tr.id == $scope.config.item.id) {return false;}
            if((tr.type || 'bracket') !== type) {return false;}

            var eq = function(prop) {
                return tr[prop] == util.getValueForField($scope.config.control.getField(prop));
            };

            if(type === 'group') {
                // Group rules may legitimately share a target division (merging
                // several sources into one all-vs-all match). position is unused
                // for them, so only an identical source is a real clash.
                return _.every(['from_competitionstep_id', 'from_division_id', 'division_id'], eq);
            }

            var from_props = ['from_competitionstep_id', 'from_division_id', 'from_position', 'position_headtohead'];
            var to_props = ['division_id', 'position'];
            return _.every(from_props, eq) || _.every(to_props, eq);
        });
    }

    var targetDivisions = options.data.targetDivisions;
    function addDivision() {
        util.showDataDialog({
            config: {
                tabs: [
                    {
                        name: 'Division',
                        fields: [
                            {name: 'name', title: 'Name', type: 'text', required: true }
                        ]
                    }
                ]
            },
            initial: {
                name: options.data.competitionstep.name
            }
        }).result.then(function(result) {
            var division = {
                id: 'new:' + Date.now(),
                name: result.name
            };
            targetDivisions.push(division);
            $scope.config.control.getField('division_id').value = division;
        });
    }

    var ruleTypeOptions = [
        {id: 'bracket', name: $filter('translate')('Playoff tree (1 vs 1)')},
        {id: 'group', name: $filter('translate')('All vs all (shared match)')}
    ];

    $scope.config = _.deep_extend(options.config, {
        datatype: 'rule',
        data: {
            steps: server.get('/api/teamsport/competitionstep/get', {gameclass_id: (options.config.data.gameclass).id }),
            fromdivisions: options.item ? server.get('/api/teamsport/division/get', {competitionstep_id: options.item.from_competitionstep_id }) : []
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'rule_type', title: 'Advancement type', type: 'select', required: true, useId: true, options: function() { return ruleTypeOptions; } },
                    {name: 'from_competitionstep_id', title: 'From', type: 'select', required: false, options: function() { return $scope.config.data.steps;}, optionsFilter: function(s) { return !options.data.competitionstep.id || s.id != options.data.competitionstep.id; }, useId: true, change: fetchDivisions },
                    {name: 'from_division_id', title: 'Division', type: 'select', required: false, options: function() { return $scope.config.data.fromdivisions;}, optionsFilter: function() { return true; }, useId: true, placeholder: 'From all divisions' },
                    {name: 'from_position', title: 'Position', type: 'number', required: true, min: 1, visible: function() { return ruleType() === 'bracket'; } },
                    {name: 'position_headtohead', title: 'Head to head position', type: 'number', min: 1, required: false, visible: function() { var f = $scope.config.control.getField('from_division_id'); return ruleType() === 'bracket' && !(f && f.value); } },
                    {name: 'competitionstep_name', title: 'To', type: 'label', getValue: function() { return options.data.competitionstep.name; } },
                    {name: 'division_id', title: 'Division', type: 'select', required: true, options: function() {return targetDivisions;}, optionsFilter: function() { return true; }, useId: true, addButtonClicked: addDivision, addButtonTitle: 'Add' },
                    {name: 'position', title: 'Position', type: 'number', required: true, min: 1, max: 2, visible: function() { return ruleType() === 'bracket'; } },
                    {name: 'count', title: 'Number advancing', type: 'number', required: true, min: 1, visible: function() { return ruleType() === 'group'; } },
                    {hint: 'Rule collides with another rule', hintClass: 'alert-danger', visible: hasRule },
                    {name: 'swap', title: 'Swap rules', type: 'checkbox', visible: function() {return $scope.config.item && hasRule();} }
                ]
            }
        ],
        canSubmit: function() {
            return !hasRule() || $scope.config.control.getField('swap').value;
        }
    });
}]);

teamsports.controller('CompetitionStepDataCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'teamsportutil', 'util', 'options', '$q', function($rootScope, $scope, $filter, $modal, server, teamsportutil, util, options, $q) {

    var targetDivisions = [];
    if(options.item && options.item.id) {
        server.get('/api/teamsport/division/get', {competitionstep_id: options.item.id }).then(function(result) {
            targetDivisions = result;
        });
    }

    function addRule() {
        var thisstep = $scope.config.control.getSubmitItem();
        var rules = $scope.config.control.getField('transition_rules').value;
        util.showDataDialog({controller: 'CompetitionStepTransitionRuleDataCtrl', data: {gameclass: options.config.data.gameclass || options.item.gameclass, competitionstep: thisstep, rules: rules, targetDivisions: targetDivisions} }).result.then(function(result) {
            result.type = result.rule_type || 'bracket';
            delete result.rule_type;
            result.id = 'new:' + Date.now();
            $scope.config.control.getField('transition_rules').value.push(result);
            $scope.config.control.getField('transition_rules').config.control.update();
        });
    }

    function changeRule(item) {
        var thisstep = $scope.config.control.getSubmitItem();
        var rules = $scope.config.control.getField('transition_rules').value;
        var editItem = angular.copy(item);
        editItem.rule_type = editItem.type || 'bracket';
        util.showDataDialog({controller: 'CompetitionStepTransitionRuleDataCtrl', item: editItem, data: {gameclass: options.config.data.gameclass || options.item.gameclass, competitionstep: thisstep, rules: rules, targetDivisions: targetDivisions}}).result.then(function(result) {
            if(result.swap) {
                var from_props = ['from_competitionstep_id', 'from_division_id', 'from_position', 'position_headtohead'];
                var to_props = ['division_id', 'position'];
                var rules = $scope.config.control.getField('transition_rules').value;
                _.any(rules, function(rule) {
                    if(rule === item) {return false;}
                    function eq(p) {return rule[p] == result[p];}
                    function swap(p) {var t = rule[p]; rule[p] = item[p]; item[p] = t;}
                    var a = _.every(from_props, eq);
                    var b = _.every(to_props, eq);
                    if(!a && b) {
                        to_props.forEach(swap);
                        return true;
                    } else if(a && !b) {
                        from_props.forEach(swap);
                        return true;
                    }
                });
            } else {
                _.extend(item, result);
                item.type = result.rule_type || 'bracket';
                delete item.rule_type;
            }
            $scope.config.control.getField('transition_rules').config.control.update();
        });
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'step',
        url: {
            add: '/api/teamsport/competitionstep/add',
            change: '/api/teamsport/competitionstep/change'
        },
        beforeSubmit: function(item) {
            return $q.promise(function(resolve) {
                item._new_divisions = [];
                targetDivisions.forEach(function(d) {
                    if(d && d.id && d.id.startsWith && d.id.startsWith('new:')) {item._new_divisions.push(d);}
                });
                resolve(item);
            });
        },
        data: {
            gameclasses: [options.config.data.gameclass || options.item.gameclass],
            divisions: server.get('/api/teamsport/division/get', {gameclass_id: (options.config.data.gameclass || options.item.gameclass).id}),
            tables: server.get('/api/teamsport/table/get'),
            steps: server.get('/api/teamsport/competitionstep/get', {gameclass_id: (options.config.data.gameclass || options.item.gameclass).id })
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'gameclass_id', title: 'Game class', type: 'select', required: true, readonly: true, useId: true, options: function() {return $scope.config.data.gameclasses; } },
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    //{name: 'number_of_divisions', title: 'Number of divisions', type: 'number', min: 1, required: true},
                    //{name: 'number_of_teams_per_division', title: 'Number of teams per division', type: 'number', min: 2, required: true},
                    {name: 'number_of_meetings', title: 'Number of meetings', type: 'number', min: 1, required: true},
                    {name: 'registration', title: 'Can register to this step', type: 'checkbox', visible: function() { return $rootScope.hasModule('Cup'); }},
                    {name: 'random_registration', title: 'Assign registrations randomly', type: 'checkbox', visible: function() { return $scope.config.control.getField('registration').value && $rootScope.hasModule('Cup'); }},
                    {name: 'best_of', title: 'Best of', type: 'checkbox', visible: function() { return $scope.config.control.getField('number_of_meetings').value > 1; } },
                    {name: 'table_id', title: 'Table', required: false, type: 'select', options: function() { return $scope.config.data.tables; }, useId: true, addButtonClicked: $scope.addTable, addButtonTitle: 'Add' }
//                    {name: 'match_length', title: 'Match length', type: 'infoNumber', info: 'minutes', required: true }
                ]
            },
            {
                name: 'Transition rules',
                fields: [
                    {name: 'transition_rules', title: 'Transition rules', type: 'customertable', getValue: function(f) { return f.config.control && f.config.control.getItems(); }, config: {
                        /*api: {
                            url: '/api/teamsport/competitionstep/rule/get',
                            args: {
                                competitionstep_id: options.item.id
                            },
                            triggers: [{type: 'competitionsteptransitionrule'}],
                            transform: function(rule) {
                                rule.from_competitionstep = _.findWhere($scope.config.data.steps, {id: rule.from_competitionstep_id });
                                return rule;
                            }
                        },*/
                        getItems: function() {
                            return $scope.config.control.getField('transition_rules').value;
                        },
//                        idKey: 'name',
                        showSum: false,
                        countSuffixList: ['rule', 'rules'],
                        columns: [
                            {field: 'name', title: 'Name' },
                            {field: 'from_competitionstep.name', title: 'From', getValue: function(f) { var from_competitionstep = _.findWhere($scope.config.data.steps, {id: f.from_competitionstep_id }); return from_competitionstep && from_competitionstep.name; } },
                            {field: 'from_division.name', title: 'Division', getValue: function(f) { var from_division = _.findWhere($scope.config.data.divisions, {id: f.from_division_id }); return from_division && from_division.name; } },
                            {field: 'from_position', title: 'Position'},
                            {field: 'division.name', title: 'To', getValue: function(f) { var division = _.findWhere(targetDivisions, {id: f.division_id }); return division && division.name; } },
                            {field: 'position', title: 'Position', getValue: function(f) { return f.type === 'group' ? f.count : f.position; } }
                        ],
                        searchButtons: [
                            {title: 'Add', onClick: addRule, showOnEmpty: true }
                        ],
                        buttons: [
                            { title: 'Change', buttonClass: 'btn-warning', onClick: changeRule },
                            { title: 'Remove', buttonClass: 'btn-danger', onClick: function(r) { var rules = $scope.config.control.getField('transition_rules').value; var i = rules.indexOf(r); rules.splice(i, 1); $scope.config.control.getField('transition_rules').config.control.update(); } }
                        ]
                    }}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    number_of_divisions: 1,
                    number_of_meetings: 1,
                    number_of_teams_per_division: 2,
                    transition_rules: []
                };
            } else {
                if (options.item.transition_rules) {
                    options.item.transition_rules = options.item.transition_rules.map(function(rule, i) { rule.id = i+1; return rule; });
                }
            }
        }
    });
}]);

teamsports.controller('TeamSportDataCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'teamsportutil', 'util', 'options', function($rootScope, $scope, $filter, $modal, server, teamsportutil, util, options) {
    $scope.addWorkoutType = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'WorkoutTypeAddCtrl',
            resolve: {
                options: function() {
                    return {
                        category: null
                    };
                }
            }
        });
        modalInstance.result.then(function(addedWorkoutType) {
            var wt = $scope.config.control.getField('workout_type_id');
            util.waitForNewObject(addedWorkoutType.id, function(id) { return _.findWhere(wt.options(), {id: id}); }, 'workouttype').then(function(workouttype) {
                wt.value = workouttype;
            });
        });
    };

    $scope.addEventType = function() {
        $modal.open({
            templateUrl: 'views/teamsporteventtypeadd.html',
            controller: 'TeamSportEventTypeAddCtrl'
        }).result.then(function(added) {
            $scope.config.data.eventtypes.push(added);
            var et = $scope.config.control.getField('eventtypes');
            if (!et.value || !et.value.length) {
                $scope.config.control.getField('eventtypes').value = [];
            }
            $scope.config.control.getField('eventtypes').value.push(added);
        });
    };

    var referee_responsible = function() {
        return $scope.config.control.getField('referee_responsible_for_formations').value;
    };

    var teamleader_responsible = function() {
        return $scope.config.control.getField('teamleader_submit_formation').value;
    };

    $scope.config = _.deep_extend(options.config, {
        datatype: 'team sport',
        url: {
            add: '/api/teamsport/add',
            change: '/api/teamsport/change'
        },
        data: {
            eventtypes: server.get('/api/teamsport/eventtype/get'),
            workouttypes: $rootScope.workouttypes
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'teamsport', imageOnly: true, squareThumbnail: true}},
                    {name: 'workout_type_id', title: 'Workout type', type: 'select', required: true, options: function() { return $scope.config.data.workouttypes; }, useId: true, placeholder: 'Choose here', addButtonClicked: $rootScope.currentStaff.allowCreateWorkoutType && $scope.addWorkoutType, addButtonTitle: 'New activity type', optionsFilter: function(wt) { return wt.active; }, group: function(wt) { var category = $rootScope.getPointerById(wt.category_id, $rootScope.workoutcategories); return category && category.name; } },
                    {name: 'eventtypes', title: 'Event types', type: 'multiselect', required: false, options: function() { return $scope.config.data.eventtypes; }, useId: true, placeholder: 'Choose here', addButtonClicked: $scope.addEventType, addButtonTitle: 'New event type' },
                    {name: 'timeperiods', title: 'Time periods', type: 'text', required: false, helpText: 'Separate time periods with comma' },
                    {name: 'default_result_type', title: 'Result type', type: 'select', required: true, options: function() { return teamsportutil.resulttypes; }, useId: true  },
                    {name: 'highest_is_best', title: 'Highest is best', type: 'checkbox'  },
                    {name: 'number_of_attempts', title: 'Number of attempts', helpText: 'NUMBER_OF_ATTEMPTS_HELPTEXT_SPORT', type: 'number', required: false, min: 1 },
                    {name: 'unit', title: 'Unit', helpText: 'UNIT_HELPTEXT', type: 'text', required: false, placeholder: 'm, s, kg, ...' },
                    {name: 'visibleForCustomer', title: 'Show for customers', type: 'checkbox', required: false }
                ]
            },
            {
                name: 'Team formation and attendance',
                fields: [
                    {title: 'Referee', type: 'label'},
                    {name: 'referee_responsible_for_formations', title: 'Should submit formation', helpText: 'REFEREE_FORMATION_HELPTEXT', type: 'checkbox' },
                    {name: 'referee_send_formation_reminder', title: 'Send reminder if formation is missing before match', helpText: 'REFEREE_FORMATION_REMINDER_HELPTEXT', type: 'checkbox', visible: referee_responsible },
                    {title: 'Team leaders', type: 'label'},
                    {name: 'teamleader_submit_formation', title: 'Should submit formation', helpText: 'TEAMLEADER_FORMATION_HELPTEXT', type: 'checkbox' },
                    {name: 'teamleader_send_formation_reminder', title: 'Send reminder if formation is missing before match', helpText: 'TEAMLEADER_FORMATION_REMINDER_HELPTEXT', type: 'checkbox', visible: teamleader_responsible },
                    {title: 'Attendance', type: 'label'},
                    {name: 'auto_attendance', title: 'Attendance is automatically set as present on match start', type: 'checkbox'}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    default_result_type: _.findWhere(teamsportutil.resulttypes, {id: 'number'}),
                    visibleForCustomer: true,
                    teamleader_submit_formation: true,
                    auto_attendance: true
                };
            }
        }
    });
}]);


teamsports.controller('TeamSportEventTypeAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$sce', function($rootScope, $scope, $controller, $filter, $sce) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('event type');
    };

    $scope.postUrl = '/api/teamsport/eventtype/add';

    $scope.callCloseOnSuccess = true;

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'points'}).value = 0;
        _.findWhere($scope.fields, {name: 'player'}).value = true;
        _.findWhere($scope.fields, {name: 'team'}).value = true;
        _.findWhere($scope.fields, {name: 'background_color'}).value = '#2EC1CC';
        _.findWhere($scope.fields, {name: 'text_color'}).value = '#252525';
    };

    $scope.getStyle = function() {
        return {
            'background-color': _.findWhere($scope.fields, {name: 'background_color'}).value,
            'color': _.findWhere($scope.fields, {name: 'text_color'}).value
        };
    };

    $scope.getName = function() {
        return _.findWhere($scope.fields, {name: 'name'}).value;
    };

    function isPlayer() {
        return _.findWhere($scope.fields, {name: 'player'}).value;
    }

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'points', title: 'Points', type: 'number', required: true, min: -99999, helpText: 'If this event affects the end result like a goal in soccer or winning a set in badminton' },
        {name: 'setresult', title: 'Set result', required: true, type: 'checkbox', helpText: 'Allows setting result for one competitor' },
        {name: 'team', title: 'Team', required: true, type: 'checkbox' },
        {name: 'player', title: 'Player', required: true, type: 'checkbox' },
        {name: 'suspension', title: 'Suspension', required: false, type: 'infoNumber', info: 'matches', visible: isPlayer },
        {name: 'background_color', title: 'Background color', required: true, type: 'color'},
        {name: 'text_color', title: 'Text color', required: true, type: 'color'}
    ];

    $scope.previewUrl = function() {
        let props = {
            event: {
                title: $scope.getName(),
                time: '47',
                color: _.findWhere($scope.fields, {name: 'text_color'}).value,
                background_color: _.findWhere($scope.fields, {name: 'background_color'}).value
            }
        }

        let url = '/homepage/shared/zoezi-single-component?c=zoezi-teamsport-eventtype-preview&noeditmode=true&props=' + encodeURIComponent(JSON.stringify(props));
        return $sce.trustAsResourceUrl(url);
    };

    $scope.setInitialValues();
}]);

teamsports.controller('TeamSportEventTypeChangeCtrl', ['$rootScope', '$scope', '$controller', 'teamsporteventtype', function($rootScope, $scope, $controller, teamsporteventtype) {
    $controller('TeamSportEventTypeAddCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.title = 'Change';
    $scope.titleSuffix = function() {
        return teamsporteventtype.name;
    };

    $scope.canSubmit = $scope.valuesChanged;

    $scope.item = teamsporteventtype;

    $scope.postUrl = '/api/teamsport/eventtype/change';

    $scope.setValues($scope.item);
}]);

teamsports.controller('TeamSportTopListAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', function($rootScope, $scope, $controller, $filter, $modal, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('top list');
    };

    server.get('/api/teamsport/eventtype/get').then(function(data) {
        $scope.eventtypes = data;
    });

    $scope.postUrl = '/api/teamsport/toplist/add';

    $scope.callCloseOnSuccess = true;

    $scope.addRow = function(value) {
        var possiblyRemoveField = function(field) {
            if (!field.value || field.value.length == 0) {
                $scope.fields.splice( $scope.fields.indexOf(field), 2);
                $scope.fields.forEach(function(f, i) {
                    if (f.name.startsWith('eventtype')) {
                        f.name = 'eventtype' + (i+1);
                    }
                    if (f.name.startsWith('points')) {
                        f.name = 'points' + i;
                    }
                });
            }
        };
        var row = { name: 'eventtype', title: $filter('translate')('Event type'), type: 'select', required: false, options: function() { return $scope.eventtypes; } };
        row.change = function() { possiblyRemoveField(row); };
        if (value && value.eventtype) {
            row.value = _.findWhere(row.options(), {id: value.eventtype});
        }
        $scope.fields.splice($scope.fields.length-1, 0, row);

        var prow = { name: 'points', title: $filter('translate')('Points'), type: 'number', min: -9999, required: true, value: value && value.points };
        $scope.fields.splice($scope.fields.length-1, 0, prow);
    };

    $scope.getSubmitItem = function() {
        var item = { typelist: []};
        if ($scope.item) {
            item.id = $scope.item.id;
        }
        item.name = _.findWhere($scope.fields, {name: 'name'}).value;
        item.type = _.findWhere($scope.fields, {name: 'type'}).value.id;
        item.show_num_matches = _.findWhere($scope.fields, {name: 'show_num_matches'}).value;
        item.show_limit = _.findWhere($scope.fields, {name: 'show_limit'}).value;
        var et = $scope.fields.filter(function(f) { return f.name == 'eventtype' || f.name == 'points'; });
        for (var i=0; i < et.length; i += 2) {
            var eventtype = et[i].value.id;
            var points = et[i+1].value;
            item.typelist.push( { eventtype: eventtype, points: points } );
        }
        return item;
    };

    $scope.canSubmit = function() {
        return _.findWhere($scope.fields, {name: 'eventtype'}) && $scope.fields.filter(function(f) {
            if (f.name.startsWith('eventtype')) {
                return !f.value;
            }
            return false;
        }).length == 0;
    };

    var types = [
        {id: 'player', name: 'Player'},
        {id: 'team', name: 'Team'}
    ];

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return types; }, useId: true },
        {name: 'show_num_matches', title: 'Number of played matches', type: 'checkbox'},
        {name: 'show_limit', title: 'Number of rows', type: 'number', value: 10},
        {name: 'addeventtype', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('event type'), click: function() { $scope.addRow(); } }
    ];
}]);

teamsports.controller('TeamSportTopListChangeCtrl', ['$rootScope', '$scope', '$controller', 'teamsporttoplist', function($rootScope, $scope, $controller, teamsporttoplist) {
    $controller('TeamSportTopListAddCtrl', {$scope: $scope});
    var parentGS = $scope.getSubmitItem;
    $controller('ChangeModalCtrl', {$scope: $scope});
    $scope.getSubmitItem = parentGS;

    $scope.titleSuffix = function() {
        return teamsporttoplist.name;
    };

    $scope.item = teamsporttoplist;

    $scope.postUrl = '/api/teamsport/toplist/change';

    $scope.$watch('eventtypes', function(value) {
        if (value) {
            $scope.setValues($scope.item);
            $scope.item.typelist.forEach($scope.addRow);
        }
    });
}]);

teamsports.controller('TeamSportScoringDataCtrl', ['$scope', 'options', function($scope, options) {
    var types = [
        { id: '310', name: '3-1-0' },
        { id: '210', name: '2-1-0' },
        { id: 'fis30', name: 'FIS' },
        { id: 'custom', name: 'Custom' },
        { id: 'padel', name: 'Padel' },
        { id: 'sum', name: 'Sum of results' }
    ];

    function isCustom() {
        var t = $scope.config.control.getField('type').value;
        return t && t.id == 'custom';
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'scoring',
        url: {
            add: '/api/teamsport/scoring/add',
            change: '/api/teamsport/scoring/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return types; }, useId: true },
                    {name: 'custom_type', title: 'Custom', type: 'text', required: true, visible: isCustom, helpText: 'CUSTOMSCORINGHELP' }
                ]
            }
        ]
    });
}]);

teamsports.controller('TeamSportCompetitionAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'util', 'teamsport', 'options', function($rootScope, $scope, $controller, $filter, util, teamsport, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('competition');
    };
    $scope.teamsports = [teamsport];

    $scope.postUrl = '/api/teamsport/competition/add';

    $scope.callCloseOnSuccess = true;

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'show'}).value = true;
        _.findWhere($scope.fields, {name: 'public_registration'}).value = true;
        _.findWhere($scope.fields, {name: 'require_membership'}).value = $rootScope.requireMembership;
    };

    function showForCustomer() {
        return _.findWhere($scope.fields, {name: 'show'}).value;
    }

    function isPublicRegistration() {
        return showForCustomer() && _.findWhere($scope.fields, {name: 'public_registration'}).value;
    }

    function startDateSet() {
        var start = _.findWhere($scope.fields, {name: 'startDate'});
        var end = _.findWhere($scope.fields, {name: 'endDate'});
        if (!end.value) {
            end.value = start.value;
        }
    }

    function setCancellationDate() {
        var end = _.findWhere($scope.fields, {name: 'registrationEndDate'});
        var cancel = _.findWhere($scope.fields, {name: 'lastCancellationDate'});
        if (!cancel.value) {
            cancel.value = end.value;
        }
    }

    $scope.canSubmit = function() {
        var start = _.findWhere($scope.fields, {name: 'startDate'}).value;
        var end = _.findWhere($scope.fields, {name: 'endDate'}).value;
        if (!start || !end || start.yyyymmdd() > end.yyyymmdd()) {
            return false;
        }

        var rstart = _.findWhere($scope.fields, {name: 'registrationStartDate'}).value;
        var rend = _.findWhere($scope.fields, {name: 'registrationEndDate'}).value;
        if (isPublicRegistration()) {
            return rstart.yyyymmdd() <= rend.yyyymmdd();
        }

        return true;
    };

    $scope.fields = [
        {name: 'teamsport_id', title: 'Team sport', type: 'select', required: true, readonly: true, useId: true, options: function() {return $scope.teamsports; }, value: teamsport },
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'show', title: 'Show for customers', type: 'checkbox', required: false },
        {name: 'public_registration', title: 'Public registration', type: 'checkbox', required: false, visible: showForCustomer },
        {name: 'require_membership', title: 'Require membership', type: 'checkbox', required: false, visible: function() { return $rootScope.hasModule('Membership'); } },
        {name: 'registrationStartDate', title: 'Registration start date', type: 'date', required: true, visible: isPublicRegistration },
        {name: 'registrationEndDate', title: 'Registration end date', type: 'date', required: true, visible: isPublicRegistration, change: setCancellationDate },
        {name: 'lastCancellationDate', title: 'Last cancellation date', type: 'date', required: true, visible: isPublicRegistration },
        {name: 'startDate', title: 'Start date', type: 'date', required: true, change: startDateSet },
        {name: 'endDate', title: 'End date', type: 'date', required: true },
        {name: 'short_description', title: 'COMPETITON_SHORT_DESCRIPTION', type: 'textarea', required: false, maxlength: 300 },
        {name: 'description', title: 'COMPETITON_DESCRIPTION', type: 'htmleditor', required: false },
        {name: 'copy_gameclasses', title: 'Copy game classes', type: 'checkbox', required: false, visible: function() { return options.initial; }, getValue: function(field) { return field.value ? options.initial.id : null; } },
        {name: 'copy_divisions', title: 'Copy divisions', type: 'checkbox', required: false, visible: function() { return options.initial && _.findWhere($scope.fields, {name: 'copy_gameclasses'}).value; } }
    ];

    $scope.setInitialValues();
    if (options.initial) {
        util.setValues($scope.fields, options.initial);
    }
}]);

teamsports.controller('TeamSportCompetitionChangeCtrl', ['$rootScope', '$scope', '$controller', 'competition', function($rootScope, $scope, $controller, competition) {
    $controller('TeamSportCompetitionAddCtrl', {$scope: $scope, teamsport: competition.teamsport, options: {}});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return competition.name;
    };

    $scope.item = competition;

    $scope.postUrl = '/api/teamsport/competition/change';

    $scope.setValues($scope.item);
}]);

teamsports.controller('TeamSportDivisionDataCtrl', ['$scope', '$filter', '$controller', 'teamsportutil', 'options', 'server', function($scope, $filter, $controller, teamsportutil, options, server) {
    var ableToChooseStep, competitionsteps;
    if(teamsportutil.cup() && options.data && options.data.competitionstep && options.data.competitionstep.gameclass.steps.length > 1) {
        ableToChooseStep = true;
        competitionsteps = server.get('/api/teamsport/competitionstep/get', {gameclass_id: options.data.competitionstep.gameclass_id });
    } else {
        competitionsteps = [options.config.data.competitionstep || options.item.competitionstep];
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'division',
        data: {
            competitionsteps: competitionsteps
        },
        url: {
            add: '/api/teamsport/division/add',
            change: '/api/teamsport/division/change'
        },
        tabs: [
            { name: 'General',
              fields: [
                {name: 'competitionstep_id', title: 'Step', type: 'select', required: true, readonly: !ableToChooseStep, useId: true, options: function() {return $scope.config.data.competitionsteps; }, visible: teamsportutil.cup, save: true },
                {name: 'name', title: 'Name', type: 'text', required: true }
              ]
          }
        ],
        init: function() {
            return {competitionstep_id: $scope.config.data.competitionsteps[0]};
        }
    });
}]);

teamsports.controller('TeamSportLeagueBaseSettingsCtrl', ['$scope', '$modal', 'formatter', '$filter', 'teamsportutil', 'competition', function($scope, $modal, formatter, $filter, teamsportutil, competition) {
    function league() {
        var fields = $scope.getLeagueSettingsFields();
        var gp = _.findWhere(fields, {name: 'groupplay_add'});
        return !gp.visible || gp.visible();
    }

    function changeMatchTime(field, initial) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MatchTimeCtrl',
            resolve: {
                options: function() {
                    return {value: field.value, initial: initial};
                }
            }
        }).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.getLeagueSettingsFields();
                fields.splice(fields.indexOf(field), 1);
            }
        });
    }

    $scope.addMatchTime = function(value) {
        var fields = $scope.getLeagueSettingsFields();

        var changed = function() {
            var matchtimes = fields.filter(function(field) { return field.name == 'groupplay_matchtime'; });

            return !angular.equals(matchtimes.map(function(field) { return field.value; }), $scope.config.item.groupplay_match_times);
        };

        var row = { name: 'groupplay_matchtime', title: $filter('translate')('Match time'), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { changeMatchTime(row); };
        row.getName = function() {
            return teamsportutil.getMatchTimeDisplayName(row.value);
        };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }
        };
        row.visible = function() {
            return league();
        };
        var gp = _.findWhere(fields, {name: 'groupplay_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            changeMatchTime(row, {});
        }
    };

    function changeBreak(field, initial) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'BreakTimeCtrl',
            resolve: {
                options: function() {
                    var options = {value: field.value, title: 'MATCH_BREAK'};
                    if (initial) {
                        options.initial = initial;
                    }
                    return options;
                }
            }
        }).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.getLeagueSettingsFields();
                fields.splice(fields.indexOf(field), 1);
            }
        });
    }

    $scope.addBreak = function(value) {
        var fields = $scope.getLeagueSettingsFields();
        var changed = function() {
            var breaks = fields.filter(function(field) { return field.name == 'break'; });

            return !angular.equals(breaks.map(function(field) { return field.value; }), $scope.config.item.breaks);
        };
        var row = { name: 'break', title: $filter('translate')('MATCH_BREAK').capitalize(), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { changeBreak(row); };
        row.getName = function() {
            return formatter.format('datetimeshort', Date.newFull(row.value.from)) + ' - ' + formatter.format('datetimeshort', Date.newFull(row.value.to));
        };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }
        };
        row.visible = function() {
            return league();
        };

        var gp = _.findWhere(fields, {name: 'break_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            changeBreak(row, {from: competition.startDate, to: competition.endDate});
        }
    };

    $scope.setLeagueSettings = function(item) {
        if (item.groupplay_match_times) {
            item.groupplay_match_times.forEach($scope.addMatchTime);
        }
        if (item.breaks) {
            item.breaks.forEach($scope.addBreak);
        }
    };

    $scope.getLeagueSettingsSubmitItem = function(item) {
        item = item || {};
        var matchtimes = $scope.getLeagueSettingsFields().filter(function(field) { return field.name == 'groupplay_matchtime'; });
        var breaks = $scope.getLeagueSettingsFields().filter(function(field) { return field.name == 'break'; });

        item.groupplay_match_times = matchtimes.map(function(field) { return field.value; });
        item.breaks = breaks.map(function(field) { return field.value; });
        return item;
    };
}]);

teamsports.controller('TeamSportGameClassDataCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$location', 'server', 'teamsportutil', 'formatter', 'util', 'options', function($rootScope, $scope, $controller, $filter, $modal, $location, server, teamsportutil, formatter, util, options) {
    var competition = options.config.data.competition || options.item.competition;

    function getProducts() {
        return $rootScope.getActiveProducts().filter(function(p) {
            return !p.membership && !p.valuecard && !p.giftcard && !p.blockFee && p.type != 'course' && !p.needs_to_choose_variant() && !p.type != 'tip';
        });
    }

    function setPrice() {
        var product = $scope.config.control.getField('product_id').value;
        if (product) {
            $scope.config.control.getField('price').value = product.price;
        }
    }

    $scope.addTable = function() {
        util.showDataDialog({controller: 'TeamSportTableDataCtrl'}).result.then(function(added) {
            $scope.config.data.tables.push(added);
            $scope.config.control.getField('table_id').value = added;
        });
    };

    $scope.addTopList = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamSportTopListAddCtrl'
        }).result.then(function(added) {
            $scope.config.data.toplists.push(added);
            var tl = $scope.config.control.getField('toplists');
            if (!tl.value) {
                tl.value = [];
            }
            tl.value.push(added);
        });
    };

    $scope.addProduct = function(field) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProductAddModalCtrl',
            resolve:  {
                options: function() {
                    return { product: {giftcard: false}};
                }
            }
        }).result.then(function(added) {
            util.waitForNewObject(added.id, function(id) { return _.findWhere(field.options(), {id: id}); }, 'trainingcardtype').then(function(res) {
                field.value = res;
                if (field.change) {
                    field.change();
                }
            });
        });
    };

    var bookForOtherOptions = [
        {id: 'self', name: 'Only for oneself'},
        {id: 'self+others', name: 'Primarily for oneself'},
        {id: 'others+self', name: 'Primarily for others'},
        {id: 'others', name: 'Only for others'}
    ];

    var bookForOthersFields = [];
    function getBookForOthersFields() {
        server.get('/api/settings/fields/get').then(function(fields) {
            bookForOthersFields = fields.user.filter(function(field) { return field.child; });
        });
    }
    getBookForOthersFields();

    function getBookForOthersFieldsHtml() {
        return '<label style="font-weight: normal">' + bookForOthersFields.map(function(field) {
            return util.t(field.title) + (field.required_child ? '*' : '');
        }).join(', ') + '</label><div><i>Detta ändras under inställningar - kundinformation och gäller för alla bokningar och köp åt andra</i></div>';
    }

    $scope.config = _.extend(options.config, {
        datatype: 'game class',
        url: {
            add: '/api/teamsport/gameclass/add',
            change: '/api/teamsport/gameclass/change'
        },
        data: {
            competitions: [competition],
            toplists: server.get('/api/teamsport/toplist/get'),
            tables: server.get('/api/teamsport/table/get'),
            division_names: [{id: 'division', name: 'Division 1, Division 2, ...'}, {id: 'group', name: 'Grupp A, Grupp B, ...'}, {id: 'serie', name: 'Serie 1, Serie 2, ...'}]
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'competition_id', title: 'Competition', type: 'select', required: true, readonly: true, useId: true, options: function() {return $scope.config.data.competitions; }, value: options.config.data.competition },
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'table_id', title: 'Table', required: false, type: 'select', options: function() { return $scope.config.data.tables; }, useId: true, addButtonClicked: $scope.addTable, addButtonTitle: 'Add' },
                    {name: 'toplists', title: 'Top lists', required: false, type: 'multiselect', options: function() { return $scope.config.data.toplists; }, useId: true, addButtonClicked: $scope.addTopList, addButtonTitle: 'Add' },
                ]
            },
            {
                name: 'Registration',
                fields: [
                    {name: 'individual', title: 'Individual competition', type: 'checkbox' },
                    {name: 'individual_reporting', title: 'Individual reporting', type: 'checkbox', helpText: 'INDIVIDUALREPORTINGHELP', visible: function() { return $scope.config.control.getField('individual').value; } },
                    {name: 'min_number_of_players', title: 'Min number of members per team', type: 'infoNumber', placeholder: 'No limit', required: false, visible: '!individual', helpText: 'MIN_MEMBERS_INFO' },
                    {name: 'max_number_of_teams', title: 'Max number of registrations', type: 'infoNumber', placeholder: 'No limit', required: false },
                    {name: 'canBookFor', type: 'select', required: true, title: 'Customer books', visible: function() { return $rootScope.zoeziMyBusiness && $scope.config.control.getField('individual').value; }, options: function() { return bookForOtherOptions; }, useId: true, orderPredicate: 'none' },
                    {title: 'Customer information when booking for others', type: 'html', visible: function() { var f = $scope.config.control.getField('canBookFor').value; return f && f.id && f.id.includes('others');}, getValue: getBookForOthersFieldsHtml },
                    {name: 'product_id', title: 'Registration fee', type: 'select', required: true, options: getProducts, useId: true, change: setPrice, addButtonClicked: $scope.addProduct, addButtonTitle: 'Add' },
                    {name: 'price', title: 'Price', type: 'price', required: true, visible: function() { return $scope.config.control.getField('product_id').value; } },
                    {name: 'questions', title: 'Questions at registration', required: false, type: 'multifields', options: { itemTitle: 'question', extra_fields: [{name: 'show_on_match', title: 'Visible on competition page', type: 'checkbox'}] } }
                ]
            },
            {
                name: 'Competition type',
                visible: function() { return !options.item; },
                fields: [
                    {name: 'league', title: 'League/cup', type: 'checkbox', helpText: 'LEAGUE_INFO' },
                    {name: 'create_divisions', title: 'Create divisions', type: 'checkbox', visible: 'league' },
                    {name: 'number_of_divisions', title: 'Number of divisions', type: 'number', required: true, visible: function() { return $scope.config.control.getField('league').value && $scope.config.control.getField('create_divisions').value; }, min: 1},
                    {name: 'division_name', title: 'Division name', type: 'select', required: true, visible: function() { return $scope.config.control.getField('league').value && $scope.config.control.getField('create_divisions').value; }, options: function() { return $scope.config.data.division_names; }, useId: true},
                    {name: 'cup', title: 'Endgame', type: 'checkbox', helpText: 'ENDGAME_INFO', visible: function() { return $rootScope.hasModule('Cup'); } },
                    {type: 'alert', visible: () => $scope.config.control.getField('cup').value && !$scope.config.control.getField('table_id').value, value: 'Cup requires a table for the game class', class: 'alert-danger' },
                    {name: 'one_match', title: 'One match', type: 'checkbox', visible: function() { return !$scope.config.control.getField('league').value && !$scope.config.control.getField('cup').value; } },
                    {name: 'startTime', title: 'Start time', required: true, type: 'time', visible: function() { return $scope.config.control.getField('one_match').value && !options.item; } },
                    {name: 'endTime', title: 'End time', required: true, type: 'time', visible: function() { return $scope.config.control.getField('one_match').value && !options.item; } },
                    {name: 'resources', title: 'Rooms and locations', required: false, type: 'customers', useId: true, itemTypes: ['resource'], visible: function() { return $scope.config.control.getField('one_match').value && !options.item; }}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    competition_id: $scope.config.data.competitions[0],
                    league: true,
                    groupplay_number_of_meetings: 1,
                    number_of_divisions: 1,
                    division_name: 'division',
                    canBookFor: 'self'
                };
            }
        },
        canSubmit() {
            // Make sure there is a table if Cup is used
            return !$scope.config.control.getField('cup').value || $scope.config.control.getField('table_id').value;
        },
        afterSubmit: function(result) {
            var item = $scope.config.control.getSubmitItem();
            if (item.cup) {
                $location.path('/teamsports/gameclass/' + result.id);
                window.createcup = true;
            }

            $scope.$close();
        }
    });
}]);

teamsports.controller('TableColumnDataCtrl', ['$scope', 'teamsportutil', 'server', 'options', function($scope, teamsportutil, server, options) {
    $scope.config = _.extend(options.config, {
        datatype: 'column',
        data: {
            scoring: server.get('/api/teamsport/scoring/get')
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return teamsportutil.tablecolumntypes; }, useId: true, orderPredicate: 'none' },
                    {name: 'name', title: 'Name', type: 'text', required: true},
                    {name: 'mobile', title: 'Show on mobile', type: 'checkbox'},
                    {name: 'shortname', title: 'Short name', type: 'text', required: true, visible: 'mobile' },
                    {name: 'bold', title: 'Bold', type: 'checkbox'},
                    {name: 'background_color', title: 'Background color', type: 'color', placeholder: 'Use color from table'},
                    {name: 'text_color', title: 'Text color', type: 'color', placeholder: 'Use color from table'},
                    {name: 'imagesize', title: 'Image size', type: 'infoNumber', info: 'px', visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['image', 'imagename'].indexOf(type.id) != -1; } },
                    {name: 'question', title: 'Question', type: 'text', required: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['question'].indexOf(type.id) != -1; } },
                    {name: 'match_no', title: 'Match', type: 'number', min: 1, required: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['match'].indexOf(type.id) != -1; } },
                    {name: 'scoring_id', title: 'Scoring', type: 'select', required: true, options: function() { return $scope.config.data.scoring; }, useId: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['points'].indexOf(type.id) != -1; } }
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    mobile: true,
                    imagesize: 30
                };
            }
        }
    });
}]);

teamsports.controller('TableColumnSortingDataCtrl', ['$scope', '$filter', 'teamsportutil', 'server', 'options', function($scope, $filter, teamsportutil, server, options) {
    function typeChanged() {
         $scope.config.control.getField('descending').value = !!$scope.config.control.getField('type').value.descending;
    }

    $scope.config = _.extend(options.config, {
        datatype: 'column',
        data: {
            scoring: server.get('/api/teamsport/scoring/get')
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return teamsportutil.tablecolumntypes; }, optionsFilter: function(ct) { return ct.sortable; }, useId: true, orderPredicate: 'none', change: typeChanged },
                    {name: 'descending', title: 'Sort descending', type: 'checkbox'},
                    {name: 'question', title: 'Question', type: 'text', required: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['question'].indexOf(type.id) != -1; } },
                    {name: 'match_no', title: 'Match', type: 'number', min: 1, required: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['match'].indexOf(type.id) != -1; } },
                    {name: 'scoring_id', title: 'Scoring', type: 'select', required: true, options: function() { return $scope.config.data.scoring; }, useId: true, visible: function() { var type = $scope.config.control.getField('type').value; return type &&  ['points'].indexOf(type.id) != -1; } }
                ]
            }
        ]
    });
}]);

teamsports.controller('TableLineDataCtrl', ['$scope', 'teamsportutil', 'options', function($scope, teamsportutil, options) {
    $scope.config = _.extend(options.config, {
        datatype: 'line',
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true},
                    {name: 'position', title: 'After position', type: 'number', required: true},
                    {name: 'from_bottom', title: 'From the bottom', type: 'checkbox'},
                    {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return teamsportutil.tablelinetype; }, useId: true, orderPredicate: 'nosort' },
                    {name: 'background_color', title: 'Background color', type: 'color', placeholder: 'Use color from table'},
                    {name: 'text_color', title: 'Text color', type: 'color', placeholder: 'Use color from table'}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    type: 'thin'
                };
            }
        }
    });
}]);

teamsports.controller('TeamSportTableDataCtrl', ['$scope', '$filter', 'util', 'teamsportutil', 'options', function($scope, $filter, util, teamsportutil, options) {
    $scope.changeColumn = function(field) {
        util.showDataDialog({controller: 'TableColumnDataCtrl', item: field.value}).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.config.control.getTab('Columns').fields;
                fields.splice(fields.indexOf(field), 1);
            }
        });
    };

    $scope.addColumn = function(value) {
        var fields = $scope.config.control.getTab('Columns').fields;

        var changed = function() {
            var columns = fields.filter(function(field) { return field.name == 'column'; });

            return !angular.equals(columns.map(function(field) { return field.value; }), $scope.config.item.columns);
        };

        var row = { name: 'column', title: $filter('translate')('Column'), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { $scope.changeColumn(row); };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }
        };
        var gp = _.findWhere(fields, {name: 'column_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            row.buttonClick();
        }
    };

    $scope.changeSortingColumn = function(field) {
        util.showDataDialog({controller: 'TableColumnSortingDataCtrl', item: field.value}).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.config.control.getTab('Sorting').fields;
                fields.splice(fields.indexOf(field), 1);
            }
        });
    };

    $scope.addSortingColumn = function(value) {
        var fields = $scope.config.control.getTab('Sorting').fields;

        var changed = function() {
            var columns = fields.filter(function(field) { return field.name == 'sorting_column'; });

            return !angular.equals(columns.map(function(field) { return field.value; }), $scope.config.item.sorting);
        };

        var row = { name: 'sorting_column', title: $filter('translate')('Column'), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { $scope.changeSortingColumn(row); };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }
        };
        row.getName = function() {
            return $filter('translate')(_.findWhere(teamsportutil.tablecolumntypes, {id: row.value.type}).name);
        };
        var gp = _.findWhere(fields, {name: 'sorting_column_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            row.buttonClick();
        }
    };

    $scope.changeLine = function(field) {
        util.showDataDialog({controller: 'TableLineDataCtrl', item: field.value}).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.config.control.getTab('Lines').fields;
                fields.splice(fields.indexOf(field), 1);
            }
        });
    };

    $scope.addLine = function(value) {
        var fields = $scope.config.control.getTab('Lines').fields;

        var changed = function() {
            var lines = fields.filter(function(field) { return field.name == 'line'; });

            return !angular.equals(lines.map(function(field) { return field.value; }), $scope.config.item.lines);
        };

        var row = { name: 'line', title: $filter('translate')('Line'), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { $scope.changeLine(row); };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }
        };
        var gp = _.findWhere(fields, {name: 'line_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            row.buttonClick();
        }
    };

    $scope.config = _.extend(options.config, {
        datatype: 'table',
        url: {
            add: '/api/teamsport/table/add',
            change: '/api/teamsport/table/change'
        },
        data: {},
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true}
                ]
            },
            {
                name: 'Viewing',
                fields: [
                    {name: 'header', title: 'Show header row', type: 'checkbox'},
                    {name: 'background_color', title: 'Background color', type: 'color', placeholder: 'Use default color'},
                    {name: 'text_color', title: 'Text color', type: 'color', placeholder: 'Use default color'},
                    {name: 'limit_items_shown', title: 'Limit number of rows', type: 'checkbox'},
                    {name: 'show_limit', title: 'Number of rows', type: 'number', required: true, visible: 'limit_items_shown', min: 1},
                    {name: 'pagination', title: 'Split into pages', type: 'checkbox'},
                    {name: 'items_per_page', title: 'Number of rows per page', type: 'number', required: true, visible: 'pagination', min: 1},
                ]
            },
            {
                name: 'Columns',
                fields: [
                    {name: 'column_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('column'), click: function() { $scope.addColumn(); } }
                ]
            },
            {
                name: 'Sorting',
                fields: [
                    {name: 'sorting_column_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('column'), click: function() { $scope.addSortingColumn(); } }
                ],
                getAdditionalMissingCount: function() {
                    return $scope.config.control.getField('sorting_column') ? 0 : 1;
                }
            },
            {
                name: 'Lines',
                fields: [
                    {name: 'line_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('line'), click: function() { $scope.addLine(); } }
                ]
            }
        ],
        init: function() {
            if (options.item) {
                if (options.item.columns) {
                    options.item.columns.forEach($scope.addColumn);
                }
                if (options.item.sorting) {
                    options.item.sorting.forEach($scope.addSortingColumn);
                }
                if (options.item.lines) {
                    options.item.lines.forEach($scope.addLine);
                }
            }
            else {
                return {
                    header: true,
                    limit_items_shown: false,
                    show_limit: 25,
                    pagination: false,
                    items_per_page: 25
                };
            }
        },
        changed: function() {
            if (options.item.lines) {
                var lines = $scope.config.control.getFields().filter(function(field) { return field.name == 'line'; });
                if (options.item.lines.length != lines.length) {
                    return true;
                }
            }
        },
        canSubmit: function() {
            return $scope.config.control && !!$scope.config.control.getField('column') && !!$scope.config.control.getField('sorting_column');
        },
        getSubmitItem: function() {
            var item = $scope.config.control.getSubmitItem();
            var columns = $scope.config.control.getFields().filter(function(field) { return field.name == 'column'; });
            var sorting_columns = $scope.config.control.getFields().filter(function(field) { return field.name == 'sorting_column'; });
            var lines = $scope.config.control.getFields().filter(function(field) { return field.name == 'line'; });

            item.columns = columns.map(function(field) { return field.value; });
            item.sorting = sorting_columns.map(function(field) { return field.value; });
            item.lines = lines.map(function(field) { return field.value; });

            return item;
        },
    });
}]);

teamsports.controller('MatchTimeCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'teamsportutil', 'options', function($rootScope, $scope, $controller, $filter, teamsportutil, options) {
    $controller('AddCtrl', {$scope: $scope});

    options = options || {};

    if (options.value) {
        $controller('ChangeModalCtrl', {$scope: $scope});
        $scope.title = 'Change';
    }

    $scope.titleSuffix = function() {
        return $filter('translate')('match time');
    };

    function updateWeekday() {
        var weekday = _.findWhere($scope.fields, {name: 'fromDate'}).value.getDay() || 7;
        _.findWhere($scope.fields, {name: 'weekday'}).value = _.findWhere(teamsportutil.weekdays, {id: weekday});
    }

    $scope.setInitialValues = function() {
        var i = options.initial || {};
        _.findWhere($scope.fields, {name: 'interval'}).value = _.findWhere(teamsportutil.intervals, {id: i.interval || 1});
        var startTime = new Date();
        startTime.setHours(18,0);
        var endTime = new Date();
        endTime.setHours(19,0);

        _.findWhere($scope.fields, {name: 'from'}).value = i.from || startTime;
        _.findWhere($scope.fields, {name: 'to'}).value = i.to || endTime;

        var startDate = Date.today().addDays(1);
        _.findWhere($scope.fields, {name: 'fromDate'}).value = i.fromDate || startDate;
        _.findWhere($scope.fields, {name: 'toDate'}).value = i.toDate || startDate;
        updateWeekday();
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From date', required: true, type: 'date', change: updateWeekday},
        {name: 'toDate', title: 'To date', required: true, type: 'date'},
        {name: 'weekday', title: 'Week day', required: true, type: 'select', options: function(){return teamsportutil.weekdays;}, useId: true, orderPredicate: 'id'},
        {name: 'interval', title: 'When', required: true, type: 'select', options: function(){return teamsportutil.intervals;}, useId: true, orderPredicate: 'id'},
        {name: 'from', title: 'From', required: true, type: 'time'},
        {name: 'to', title: 'To', required: true, type: 'time'},
        {name: 'resources', title: 'Rooms and locations', required: true, type: 'customers', useId: true, itemTypes: ['resource']}
    ];

    function timeOK() {
        return _.findWhere($scope.fields, {name: 'fromDate'}).value.yyyymmdd() <= _.findWhere($scope.fields, {name: 'toDate'}).value.yyyymmdd() &&
               _.findWhere($scope.fields, {name: 'from'}).value.hhmm() < _.findWhere($scope.fields, {name: 'to'}).value.hhmm();
    }

    $scope.canSubmit = function() {
        return timeOK() && (!options.value || $scope.valuesChanged());
    };

    $scope.submit = function() {
        $scope.$close($scope.getSubmitItem());
    };

    $scope.setInitialValues();

    if (options.value) {
        $scope.item = options.value;
        $scope.setValues($scope.item);
    }
}]);

teamsports.controller('BreakTimeCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'teamsportutil', 'options', function($rootScope, $scope, $controller, $filter, teamsportutil, options) {
    $controller('AddCtrl', {$scope: $scope});

    options = options || {};

    if (options.value) {
        $controller('ChangeModalCtrl', {$scope: $scope});
        $scope.title = 'Change';
    }

    $scope.titleSuffix = function() {
        return $filter('translate')(options.title || 'BREAK').toLowerCase();
    };

    $scope.setInitialValues = function() {
        if (options.initial) {
            _.keys(options.initial).forEach(function(key) {
                _.findWhere($scope.fields, {name: key}).value = options.initial[key];
            });
        }
    };

    $scope.fields = [
        {name: 'from', title: 'From', required: true, type: options.type || 'datetime'},
        {name: 'to', title: 'To', required: true, type: options.type || 'datetime'}
    ];

    $scope.canSubmit = function() {
        return _.findWhere($scope.fields, {name: 'from'}).value < _.findWhere($scope.fields, {name: 'to'}).value;
    };

    $scope.submit = function() {
        $scope.$close($scope.getSubmitItem());
    };

    $scope.setInitialValues();

    if (options.value) {
        $scope.item = options.value;
        $scope.setValues($scope.item);
        $scope.canSubmit = $scope.valuesChanged;
    }
}]);

teamsports.controller('TeamSportCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'confirm', 'server', 'live', 'util', '$routeParams', 'teamsportutil', '$location', function($rootScope, $scope, $modal, $filter, confirm, server, live, util, $routeParams, teamsportutil, $location) {

    $scope.addCompetition = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamSportCompetitionAddCtrl',
            resolve: {
                teamsport: function() {
                    return $scope.teamsport;
                },
                options: function() {
                    return {};
                }
            }
        });
    };

    $scope.changeCompetition = function(competition) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamSportCompetitionChangeCtrl',
            resolve: {
                competition: function() {
                    return competition;
                }
            }
        });
    };

    $scope.copyCompetition = function(competition) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamSportCompetitionAddCtrl',
            resolve: {
                teamsport: function() {
                    return $scope.teamsport;
                },
                options: function() {
                    return {initial: competition};
                }
            }
        });
    };

    $scope.getRegistrations = function(competition) {
        server.get('/api/teamsport/team/export', { competition_id: competition.id }, null, {responseType: 'blob'}).then(function(data) {
            var filename = $filter('translate')('Registrations') + '.xlsx';
            util.download(filename, null, null, data);
        });
    };

    function visibleColumn(config, column) {
        if (config.context && config.context.columns) {
            return config.context.columns.indexOf(column.field) != -1;
        }
    }

    $scope.sendMailing = function(config) {
        $modal.open({
            templateUrl: 'views/teamsportsendmailingmodal.html',
            controller: 'TeamSportSendMailingCtrl',
            resolve: {
                competitionIds: function() {
                    return _.pluck(config.control.getFilteredItems(), 'id');
                }
            }
        });
    };

    function isHistory(c) {
        return c.endDate.isPastDate();
    }

    function isUpcoming(c) {
        return c.registrationStartDate && c.registrationStartDate.isFutureDate();
    }

    function isRegistrationOpen(c) {
        return (!c.registrationEndDate || !c.registrationEndDate.isPastDate()) && !isUpcoming(c) && !isHistory(c);
    }

    function isOngoing(c) {
        return !isRegistrationOpen(c) && !isUpcoming(c) && !isHistory(c);
    }

    $scope.removeCompetition = function(c) {
        confirm.show('Are you sure you want to remove the competition?').then(function() {
            server.post('/api/teamsport/competition/remove', null, {id: c.id}, '{0} was removed', 'Failed to remove {0}', 'competition');
        });
    };

    $scope.competitionConfig = {
        api: {
            url: '/api/teamsport/competition/get',
            args: {
                teamsport_id: $routeParams.teamsportId
            },
            triggers: [{type: 'teamsportcompetition'}],
            transform: teamsportutil.transformCompetition
        },
        countSuffixList: ['competition', 'competitions'],
        giveFocus: function() { return false; },
        tabs: [
            { name: 'Registration open', badgeClass: 'badge-warning', itemFilter: isRegistrationOpen, context: { columns: ['registrationStartDate', 'registrationEndDate', 'numTeams'] } },
            { name: 'Upcoming registrations', badgeClass: 'badge-warning', itemFilter: isUpcoming, context: { columns: [] } },
            { name: 'ongoing2', badgeClass: 'badge-success', itemFilter: isOngoing, context: { columns: [] } },
            { name: 'History', itemFilter: isHistory, context: { columns: [] } }
        ],
        rowClick: function(s) {
            $location.path('/teamsports/competition/' + s.id);
        },
        orderColumn: 'name',
        columns: [
            {field: 'name', title: 'Name' },
            {field: 'registrationStartDate', title: 'Registration start date', format: 'date', visible: visibleColumn },
            {field: 'registrationEndDate', title: 'Registration end date', format: 'date', visible: visibleColumn },
            {field: 'numTeams', title: 'Number of registered', visible: visibleColumn }
        ],
        searchButtons: [
            {title: 'Add', onClick: $scope.addCompetition, showOnEmpty: true},
            {title: 'Send mailing', onClick: $scope.sendMailing}
        ],
        buttons: [
            { title: 'Get registrations', buttonClass: 'btn-success', visible: function(c) { return $rootScope.hasPermission('Competition handling') && !isUpcoming(c); }, onClick: $scope.getRegistrations },
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeCompetition },
            { title: 'Copy', buttonClass: 'btn-info', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.copyCompetition },
            { title: 'Remove', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.removeCompetition }
        ]
    };

    function fetchTeamSport() {
        server.get('/api/teamsport/get', {id: $routeParams.teamsportId}).then(function(data) {
            $scope.teamsport = data;
        });
    }
    fetchTeamSport();

    live.subscribe( {
        type: 'teamsport',
        scope: $scope,
        callback: function(ts) {
            if (ts.id == $scope.teamsport.id) {
                fetchTeamSport();
            }
        }
    });
}]);

teamsports.controller('TeamSportSendMailingCtrl', ['$rootScope', '$scope', '$location', '$routeParams', '$q', 'server', 'competitionIds', function($rootScope, $scope, $location, $routeParams, $q, server, competitionIds) {
    $scope.title = 'Mailing';
    $scope.loadingStatus = {};

    var getReceivers = function () {
        if (competitionIds && !competitionIds.length) {
            return $q.when({members: [], leaders: []});
        }
        $scope.loadingStatus.loading = true;
        var params = {};
        if ($routeParams.teamsportId) {
            params = {teamsport_id: $routeParams.teamsportId};
        } else if ($routeParams.competitionId) {
            params = {competition_id: $routeParams.competitionId};
        } else if ($routeParams.gameclassId) {
            params = {gameclass_id: $routeParams.gameclassId};
        } else {
            params = {division_id: $routeParams.divisionId};
        }
        if (competitionIds && competitionIds.length) {
            params.competition_ids = competitionIds.join(',');
        }
        return server.get('/api/teamsport/participants/get', params);
    };

    $scope.sendMailingToTeamMembers = function() {
        getReceivers().then(function(receivers) {
            $scope.$close();
            $scope.pubsub.publish('newmailingdata', {isNewsOrAdvertising: false, sendOption: 'mail', receivers: receivers.members});
            $location.path('/mailings/new');
        });
    };

    $scope.sendMailingToTeamLeaders = function() {
        getReceivers().then(function(receivers) {
            $scope.$close();
            $scope.pubsub.publish('newmailingdata', {isNewsOrAdvertising: false, sendOption: 'mail', receivers: receivers.leaders});
            $location.path('/mailings/new');
        });
    };
}]);

teamsports.controller('TeamSportCompetitionCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'confirm', 'server', 'live', 'util', '$routeParams', 'teamsportutil', '$location', 'alertProvider', function($rootScope, $scope, $modal, $filter, confirm, server, live, util, $routeParams, teamsportutil, $location, alertProvider) {

    $scope.addGameClass = function() {
        util.showDataDialog({controller: 'TeamSportGameClassDataCtrl', data: {competition: $scope.competition } });
    };

    $scope.changeGameClass = function(gameclass) {
        util.showDataDialog({controller: 'TeamSportGameClassDataCtrl', item: gameclass, data: { competition: $scope.competition } });
    };

    $scope.copyGameClass = function(gameclass) {
        util.showDataDialog({controller: 'TeamSportGameClassDataCtrl', initial: gameclass, data: {competition: $scope.competition } });
    };

    $scope.removeGameClass = function(gameclass) {
        confirm.show('Are you sure you want to remove the game class?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/gameclass/remove', null, {id: gameclass.id}, 'Game class removed', 'Failed to remove game class').then(resolve);
        });
    };

    var createMatches = function(options) {
        $modal.open({
            templateUrl: 'views/creatematches.html',
            controller: 'TeamSportCreateMatchesCtrl',
            resolve: {
                options: function() {
                    return options;
                }
            }
        });
    };

    var assignTimes = function(options) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'AssignTimesCtrl',
            resolve: {
                options: function() {
                    return options;
                }
            }
        });
    };

    var removeMatchTimes = function(filter) {
        confirm.show('Are you sure you want to remove all match times?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/times/remove', filter, null, 'Match times removed', 'Failed to remove match times').then(resolve);
        });
    };

    $scope.removeMatches = function() {
        server.get('/api/teamsport/match/has_played', {competition_id: $routeParams.competitionId}).then(function(result) {
            if (result.has_played_matches) {
                alertProvider.modal('Error', 'Cannot remove all matches for a competition where there are played matches');
            } else {
                confirm.show('Are you sure you want to remove all matches?', {ladda: true}).then(function(resolve) {
                    server.post('/api/teamsport/competition/removematches', null, {id: $routeParams.competitionId}).then(resolve);
                });
            }
        });
    };

    var gameClassRemoveMatches = function(gc) {
        server.get('/api/teamsport/match/has_played', {gameclass_id: gc.id}).then(function(result) {
            if (result.has_played_matches) {
                alertProvider.modal('Error', 'Cannot remove all matches for a game class where there are played matches');
            } else {
                confirm.show('Are you sure you want to remove all matches?', {ladda: true}).then(function(resolve) {
                    server.post('/api/teamsport/gameclass/removematches', null, {id: gc.id}).then(resolve);
                });
            }
        });
    };

    $scope.getRegistrations = function() {
        server.get('/api/teamsport/team/export', { competition_id: $routeParams.competitionId }, null, {responseType: 'blob'}).then(function(data) {
            var filename = $filter('translate')('Registrations') + '.xlsx';
            util.download(filename, null, null, data);
        });
    };

    $scope.sendMailing = function() {
        $modal.open({
            templateUrl: 'views/teamsportsendmailingmodal.html',
            controller: 'TeamSportSendMailingCtrl',
            resolve: {
                competitionIds: function() {
                    return null;
                }
            }
        });
    };

    $scope.config = {
        api: {
            url: '/api/teamsport/gameclass/get_compact_list',
            args: {
                competition_id: $routeParams.competitionId,
                mode: 'buttons'
            },
            triggers: [{type: 'teamsportgameclass'}],
            onItemsUpdated: function(items) {
                $scope.config.isLeague = !!_.find(items, function(gc) { return gc.league; });
                $scope.config.isOneMatch = !!_.find(items, function(gc) { return gc.one_match; });
                $scope.config.control.rebuild();
            }
        },
        countSuffixList: ['game class', 'game classes'],
        rowClick: function(g) {
            $location.path('/teamsports/gameclass/' + g.id);
        },
        giveFocus: function() { return false; },
        orderColumn: 'name',
        orderOptions: {numeric: true},
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'num_teams', title: 'Number of registered'},
            {field: 'num_divisions', title: 'Number of divisions', visible: function() { return $scope.config.isLeague; } }
        ],
        searchButtons: [
            {title: 'Add game class', onClick: $scope.addGameClass, showOnEmpty: true, visible: function() { return $scope.competition; }},
            {title: 'Get registrations', buttonClass: 'btn-success', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.getRegistrations },
            {title: 'Create matches', onClick: function() {createMatches({competition: $scope.competition});}, showOnEmpty: true, visible: function() {return $scope.competition && $scope.competition.able_create_matches;} },
            {title: 'Assign times', onClick: function(){assignTimes({competition: $scope.competition});}, visible: function() {return $scope.competition && $scope.competition.able_assign_times;} },
            {title: 'Remove matches', buttonClass: 'btn-danger', onClick: $scope.removeMatches, showOnEmpty: true, visible: function() {return $scope.competition && $scope.competition.able_remove_matches;} },
            {title: 'Remove match times', buttonClass: 'btn-danger', onClick: function() {removeMatchTimes({competition_id: $scope.competition.id});}, visible: function() {return $scope.competition && $scope.competition.able_remove_times;} },
            {title: 'Send mailing', onClick: $scope.sendMailing}
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeGameClass },
            {title: 'Copy', buttonClass: 'btn-info', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.copyGameClass },
            {title: 'Create matches', onClick: function(gc) {createMatches({gameclass: gc, competition: $scope.competition});}, visible: function(gc) {return gc.able_create_matches;} },
            {title: 'Assign times', onClick: function(gc){assignTimes({gameclass: gc, competition: $scope.competition});}, visible: function(gc) {return gc.able_assign_times;} },
            {title: 'Remove', buttonClass: 'btn-danger', visible: function(gc) { return !gc.able_remove_matches && !gc.able_remove_times; }, onClick: $scope.removeGameClass },
            {title: 'Remove matches', buttonClass: 'btn-danger', onClick: gameClassRemoveMatches, visible: function(gc) {return gc.able_remove_matches && !gc.able_remove_times;} },
            {title: 'Remove match times', buttonClass: 'btn-danger', onClick: function(gc) {removeMatchTimes({gameclass_id: gc.id});}, visible: function(gc) {return gc.able_remove_times;} }
        ]
    };

    function fetchCompetition() {
        server.get('/api/teamsport/competition/get', {id: $routeParams.competitionId, full: false, mode: 'buttons'}).then(function(data) {
            $scope.competition = teamsportutil.transformCompetition(data);
        });
    }
    fetchCompetition();

    live.subscribe( {
        type: 'teamsportcompetition',
        scope: $scope,
        callback: function(s) {
            if (s.id == $routeParams.competitionId) {
                fetchCompetition();
            }
        }
    });
}]);

// teamsports.controller('TeamSportCreateMatchesCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'options', function($rootScope, $scope, $controller, $filter, server, options) {
//     $controller('AddCtrl', {$scope: $scope});
//     var competition = options.competition;
//     var division = options.division;
//     $scope.title = 'Create matches';
//     $scope.titleSuffix = function() {
//         return $filter('translate')('for') + ' ' + competition.name;
//     };

//     $scope.registrationOpen = function() {
//         return competition.public_registration && competition.registrationEndDate && !competition.registrationEndDate.isPastDate();
//     };

//     server.get('/api/teamsport/gameclass/get', {competition_id: competition.id}).then(function(result) {
//         $scope.gameclasses = result;
//         server.get('/api/teamsport/competition/checkcreatematches', {
//             id: competition.id,
//             division_id: division && division.id
//         }).then(function(result) {
//             if (result.timeslots) {
//                 result.timeslots.forEach(function(ts) {
//                     ts.gameclass = _.findWhere($scope.gameclasses, {id: ts.gameclass_id});
//                 });
//             }
//             result.nodivision.forEach(function(nd) {
//                 nd.gameclass = _.findWhere($scope.gameclasses, {id: nd.gameclass_id});
//             });
//             result.noteams.forEach(function(nd) {
//                 nd.gameclass = _.findWhere($scope.gameclasses, {id: nd.gameclass_id});
//             });
//             if (result.gamedays) {
//                 result.gamedays = result.gamedays.filter(function(gd) {
//                     return gd.allowed != null && gd.allowed < gd.needed;
//                 });
//                 result.gamedays.forEach(function(gd) {
//                     server.get('/api/teamsport/division/get', {id: gd.division_id}).then(function(result) {
//                         gd.gameclass = _.findWhere($scope.gameclasses, {id: result.gameclass_id});
//                         gd.division = result;
//                     });
//                 });
//             }
//             $scope.check = result;
//         });
//     });

//     $scope.fields = [
//     ];

//     $scope.canSubmit = function() {
//         return $scope.check && $scope.check.ok && !$scope.registrationOpen();
//     };

//     $scope.submit = function() {
//         $scope.loadingStatus.loading = true;
//         server.post('/api/teamsport/competition/creatematches', null, {
//             id: competition.id,
//             division_id: division && division.id
//         }, 'Matches created', 'Failed to create matches').then(function(result) {
//             if (result.success) {
//                 $scope.$close();
//             } else {
//                 $scope.loadingStatus.loading = false;
//                 $scope.errorMessage = 'Failed to create matches. Try to extend time period or reduce number of matches.';
//                 if(result.data.type == 'reservation_error') {
//                     var args = result.data.args;
//                     if(args) {
//                         $scope.errorMessage = $filter('translate')('Failed to create matches. Try to extend time period or reduce number of matches.');
//                         $scope.errorMessage += '\n' + $filter('translate')('{0} of {1} failed').replace('{0}', args.failed).replace('{1}', args.failed + args.matched) + '.';
//                     }
//                 }
//             }
//         });
//     };
// }]);

teamsports.controller('TeamSportCreateMatchesCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'options', function($rootScope, $scope, $controller, $filter, server, options) {
    $controller('AddCtrl', {$scope: $scope});
    var competition = options.competition;

    $scope.title = 'Create matches';
    $scope.callCloseOnSuccess = true;
    $scope.postUrl = '/api/teamsport/match/create';
    $scope.titleSuffix = function() {
        var name = competition.name;
        if(options.division) {
            name += ' - ' + options.division.name;
        } else if(options.step) {
            name += ' - ' + options.step.name;
        } else if(options.gameclass) {
            name += ' - ' + options.gameclass.name;
        }
        return $filter('translate')('for') + ' ' + name;
    };

    $scope.registrationOpen = function() {
        var registrationEndDate = competition.registrationEndDate;
        if(registrationEndDate && !registrationEndDate.isPastDate) {registrationEndDate = Date.newFull(registrationEndDate);}
        return competition.public_registration && registrationEndDate && !registrationEndDate.isPastDate();
    };

    function formChanged() {
        var item = $scope.getSubmitItem();
        if (!item.groupplay_number_of_meetings) { return; }
        server.get('/api/teamsport/match/checkcreate', item).then(function(result) {
            result.nodivision.forEach(function(nd) {
                nd.gameclass = _.findWhere($scope.gameclasses, {id: nd.gameclass_id});
            });
            result.noteams.forEach(function(nd) {
                nd.gameclass = _.findWhere($scope.gameclasses, {id: nd.gameclass_id});
            });
            $scope.check = result;
        });
    }

    server.get('/api/teamsport/gameclass/get', {competition_id: competition.id}).then(function(result) {
        $scope.gameclasses = result;
        formChanged();
    });


    function templateFilter(t) {
        if(t.meetings && t.meetings > 1) {
            var meetings = _.findWhere($scope.fields, {name: 'groupplay_number_of_meetings'}).value;
            return !(meetings % t.meetings);
        }
        return true;
    }

    var lotteryMethods = [];
    $scope.fields = [
        {name: 'groupplay_number_of_meetings', title: 'Number of meetings', type: 'infoNumber', info: 'meetings', required: true, value: 1, min: 1, max: 6, change: formChanged },
        {name: 'lottery_method', title: 'Lottery procedure', type: 'select', options: function() {return lotteryMethods;}, optionsFilter: templateFilter },
        {type: 'alert', value:'REGISTRATION_STILL_OPEN', 'class': 'alert-danger', visible: $scope.registrationOpen},
        {name: 'force', title: 'Create anyway', type: 'checkbox', visible: $scope.registrationOpen}
    ];


    $scope.canSubmit = function() {
        var force = _.findWhere($scope.fields, {name: 'force'}).value;
        return $scope.check && $scope.check.ok && (force || !$scope.registrationOpen());
    };

    $scope.getSubmitItem = function() {
        var lottery_method = _.findWhere($scope.fields, {name: 'lottery_method'}).value;
        var data = {
            groupplay_number_of_meetings: _.findWhere($scope.fields, {name: 'groupplay_number_of_meetings'}).value,
            lottery_method: lottery_method && lottery_method.name
        };
        if(options.division) {
            data.division_id = options.division.id;
        } else if(options.step) {
            data.competitionstep_id = options.step.id;
        } else if(options.gameclass) {
            data.gameclass_id = options.gameclass.id;
        } else if(options.competition) {
            data.competition_id = options.competition.id;
        }
        return data;
    };

    $scope.setInitialValues = function() {
        var defaultMethod = _.findWhere(lotteryMethods.filter(templateFilter), {name: 'Standard'});
        if (defaultMethod) {
            _.findWhere($scope.fields, {name: 'lottery_method'}).value = defaultMethod;
        }
    };

    server.get('/api/teamsport/template/get', $scope.getSubmitItem()).then(function(result) {
        lotteryMethods = result;
        $scope.setInitialValues();
    });
}]);

teamsports.controller('SetRefereeCtrl', ['$scope', '$controller', 'server', 'teamsportutil', 'division', function($scope, $controller, server, teamsportutil, division) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.callCloseOnSuccess = true;
    $scope.title = 'Set referee';
    $scope.postUrl = '/api/teamsport/division/setreferee';
    $scope.divisions = [division];

    function getMatches() {
        return server.get('/api/teamsport/match/get', {division_id: division.id, full: false}).then(function(res) {
            res.forEach(function(match) {
                teamsportutil.transformMatch(match);
            });
            $scope.matches = res;
            _.findWhere($scope.fields, {name: 'empty'}).value = res.filter(function(m) { return !m.referees_id.length;}).length;
        });
    }
    var gm = getMatches();

    function getGroup(match) {
        return match.referees.map(function(r){return r.name;}).join(', ') || 'No referee';
    }

    function getMatchName(match) {
        var name = teamsportutil.getMatchName(match) + ', ' + match.activity.startTime.dateTime();
        if(match.activity.resources[0]) {name += ', ' + match.activity.resources[0].name;}
        return name;
    }

    function setMatches() {
        var referees = _.findWhere($scope.fields, {name: 'referees'}).value;
        var m = _.findWhere($scope.fields, {name: 'matches'});
        if(referees.length < 1) {
            m.value = [];
            return;
        } else if (referees.length === 1) {
            gm.then(function() {
                m.value = m.options().filter(function(match) {
                    return match.referees_id.indexOf(referees[0].id) >= 0;
                });
            });
        } else {
            gm.then(function() {
                var rs = referees.map(function(r) { return r.id; });
                m.value = m.options().filter(function(match) {
                    return _.intersection(rs, match.referees_id).length === rs.length;
                });
            });
        }
    }

    function setEmpty() {
        var m = _.findWhere($scope.fields, {name: 'matches'});
        m.value = m.options().filter(function(match) {
            return (m.value || []).indexOf(match) != -1 || !match.referees_id.length;
        });
    }

    $scope.fields = [
        {name: 'division_id', title: 'Division', type: 'select', required: false, readonly: true, useId: true, options: function() {return $scope.divisions; }, value: division },
        {name: 'referees', title: 'Referee', type: 'customers', required: true, useId: true, change: setMatches},
        {name: 'empty', type: 'label', title: 'Matches without referee' },
        {name: 'set_empty', buttonTitle: 'Select all matches without referee', buttonClass: 'btn-success', type: 'button', click: setEmpty, visible: function() { return _.findWhere($scope.fields, {name: 'empty'}).value; } },
        {name: 'matches', title: 'Matches', type: 'multiselect', options: function() { return $scope.matches; }, useId: true, group: getGroup, getName: getMatchName, orderPredicate: 'activity.startTime' }
    ];
}]);

teamsports.controller('MoveTeamsCtrl', ['$rootScope', '$scope', '$controller', 'server', 'gameclass', 'division', function($rootScope, $scope, $controller, server, gameclass, division) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Move registrations';
    $scope.postUrl = '/api/teamsport/division/set_teams';
    $scope.callCloseOnSuccess = true;

    function setTeamsForDivision() {
        var division = _.findWhere($scope.fields, {name: 'division'}).value;
        var t = _.findWhere($scope.fields, {name: 'teams'});

        var value = division.teams;
        var options = t.options();
        t.value = value ? value.map(function(id) {
            return _.findWhere(options, {id: _.isObject(id) ? id.id : id});
        }).filter(Boolean) : [];
    }

    function getDivisions() {
        server.get('/api/teamsport/division/get', {gameclass_id: gameclass.id}).then(function(res) {
            $scope.divisions = res;
            if (division) {
                _.findWhere($scope.fields, {name: 'division'}).value = _.findWhere(res, {id: division.id});
                setTeamsForDivision();
            }
        });
    }

    function getGroup(team) {
        var div = _.find($scope.divisions, function(div) {
            return _.findWhere(div.teams, {id: team.id});
        });

        return div ? div.name : 'No division';
    }

    $scope.fields = [
        {name: 'division', title: 'Division', type: 'select', options: function() { return $scope.divisions; }, change: setTeamsForDivision, useId: true },
        {name: 'teams', title: 'Registrations', type: 'multiselect', options: function() { return gameclass.teams; }, visible: function() { return _.findWhere($scope.fields, {name: 'division'}).value; }, useId: true, group: getGroup, orderPredicate: [getGroup, 'name']}
    ];

    getDivisions();
}]);

teamsports.controller('CreateCupCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'util', 'gameclass', 'live', function($rootScope, $scope, $controller, $filter, server, util, gameclass, live) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Create';
    $scope.postUrl = '/api/teamsport/cup/create';
    $scope.callCloseOnSuccess = true;
    var gameclasses = [gameclass];

    $scope.titleSuffix = function() {
        return 'cup';
    };

    function countTeams() {
         if (_.findWhere($scope.fields, {name: 'groupplay'}).value) {
            var number_of_divisions;
            if (_.findWhere($scope.fields, {name: 'groupplay_step_id'}).value) {
                number_of_divisions = _.findWhere($scope.fields, {name: 'groupplay_divisions'}).value.length;
            } else {
                number_of_divisions = _.findWhere($scope.fields, {name: 'number_of_divisions'}).value;
            }
            var prog =  _.findWhere($scope.fields, {name: 'progressing'}).value;
            var p1 = _.findWhere($scope.fields, {name: 'progressing1'}).value || number_of_divisions;
            var p2 = _.findWhere($scope.fields, {name: 'progressing2'}).value || number_of_divisions;
            var p3 = _.findWhere($scope.fields, {name: 'progressing3'}).value || number_of_divisions;
            var p4 = _.findWhere($scope.fields, {name: 'progressing4'}).value || number_of_divisions;
            var p = p1;
            if (prog > 1) {
                p += p2;
            }
            if (prog > 2) {
                p += p3;
            }
            if (prog > 3) {
                p += p4;
            }

            return p;
         } else {
            return Math.pow(2, _.findWhere($scope.fields, {name: 'num_steps'}).value);
         }
    }

    function fetchDivisions() {
        $scope.divisions = [];
        var gs = _.findWhere($scope.fields, {name: 'groupplay_step_id'});
        if (gs && gs.value && gs.value.id) {
            server.get('/api/teamsport/division/get', {competitionstep_id: gs.value.id }).then(function(result) {
                $scope.divisions = result;
                _.findWhere($scope.fields, {name: 'groupplay_divisions'}).value = $scope.divisions;
            });
        }
    }

    function groupplay() {
        return _.findWhere($scope.fields, {name: 'groupplay'}).value;
    }

    function progressing() {
        return _.findWhere($scope.fields, {name: 'progressing'}).value;
    }

    function best_of() {
        return _.findWhere($scope.fields, {name: 'best_of'}).value;
    }

    function thirdplace() {
        return _.findWhere($scope.fields, {name: 'thirdplace'}).value;
    }

    function wrongNumberOfTeams() {
        return [2, 4, 8, 16, 32].indexOf(countTeams()) == -1;
    }

    $scope.canSubmit = function() {
        return !wrongNumberOfTeams() && (groupplay() || countTeams() != 2);
    };

    $scope.fields = [
        {name: 'gameclass_id', title: 'Game class', type: 'select', required: true, readonly: true, useId: true, options: function() {return gameclasses; } },
        {name: 'groupplay', title: 'Group play', type: 'checkbox' },
        {name: 'groupplay_step_id', title: 'Group play step', type: 'select', required: true, options: function() { return $scope.steps; }, useId: true, visible: function() { return groupplay() && $scope.steps.length; }, change: fetchDivisions },
        {name: 'groupplay_divisions', title: 'Divisions', type: 'multiselect', required: true, options: function() {return $scope.divisions; }, useId: true, visible: function() { return groupplay() && $scope.steps.length; } },
        {name: 'number_of_divisions', title: 'Number of groups', type: 'number', min: 1, visible: function() { return groupplay() && $scope.steps.length == 0; } },
        {name: 'progressing', title: 'Number of positions progressing', type: 'number', min: 1, max: 4, visible: groupplay},
        {name: 'progressing1', title: $filter('translate')('Position') + ' 1', type: 'number', min: 1, visible: groupplay, placeholder: 'All'},
        {name: 'progressing2', title: $filter('translate')('Position') + ' 2', type: 'number', min: 1, visible: function() { return groupplay() && progressing() >= 2; }, placeholder: 'All'},
        {name: 'progressing3', title: $filter('translate')('Position') + ' 3', type: 'number', min: 1, visible: function() { return groupplay() && progressing() >= 3; }, placeholder: 'All'},
        {name: 'progressing4', title: $filter('translate')('Position') + ' 4', type: 'number', min: 1, visible: function() { return groupplay() && progressing() >= 4; }, placeholder: 'All'},

        {name: 'num_steps', title: 'Number of steps', type: 'number', min: 1, max: 4, visible: function() { return !groupplay(); } },
        {name: 'thirdplace', title: 'Third place match', type: 'checkbox', visible: function() { return countTeams() > 2; } },
        {name: 'best_of', title: 'Best of', type: 'checkbox' },
        {name: 'best_of_step_32', title: 'Sixteen final', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() == 32; }, info: 'matches', min: 1, max: 7 },
        {name: 'best_of_step_16', title: 'Eight final', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() == 16; }, info: 'matches', min: 1, max: 7 },
        {name: 'best_of_step_8', title: 'Quarter final', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() >= 8; }, info: 'matches', min: 1, max: 7 },
        {name: 'best_of_step_4', title: 'Semi final', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() >= 4; }, info: 'matches', min: 1, max: 7 },
        {name: 'best_of_step_thirdplace', title: 'Third place match', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() > 2 && thirdplace(); }, info: 'matches', min: 1, max: 7 },
        {name: 'best_of_step_2', title: 'Final', type: 'infoNumber', required: true, visible: function() { return best_of() && countTeams() >= 2; }, info: 'matches', min: 1, max: 7 },
        {name: 'teams', title: 'Number of teams', type: 'label', getValue: countTeams, visible: () => !isNaN(countTeams()) },
        {hint: 'Number of teams must be 2, 4, 8, 16 or 32', hintClass: 'alert-danger', visible: wrongNumberOfTeams }
    ];

    function fetchSteps() {
        server.get('/api/teamsport/competitionstep/get', {gameclass_id: gameclass.id}).then(function(steps) {
            $scope.steps = steps;
            util.setValues($scope.fields, {gameclass_id: gameclasses[0], groupplay: true, groupplay_step_id: $scope.steps.length ? $scope.steps[0] : undefined, number_of_divisions: 8, progressing: 2, num_steps: 2, thirdplace: false, best_of_step_16: 1, best_of_step_8: 1, best_of_step_4: 1, best_of_step_thirdplace: 1, best_of_step_2: 1 }, {callChange: true});
        });
    }
    fetchSteps();

    live.subscribe({
        type: 'competitionstep',
        scope: $scope,
        action: 'add',
        callback: function(step) {
            if (step.gameclass_id == gameclass.id) {
                fetchSteps();
            }
        }
    });
}]);

teamsports.controller('TeamSportGameClassCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'confirm', 'server', 'live', 'util', '$routeParams', 'teamsportutil', '$location', 'alertProvider', function($rootScope, $scope, $modal, $filter, confirm, server, live, util, $routeParams, teamsportutil, $location, alertProvider) {
    $scope.cup = teamsportutil.cup();
    $scope.addDivision = function() {
        var step_id = $scope.gameclass.steps[0];
        server.get('/api/teamsport/competitionstep/get', {id: step_id}).then(function(step) {
            util.showDataDialog({controller: 'TeamSportDivisionDataCtrl', data: {competitionstep: step}});
        });
    };

    $scope.changeDivision = function(division) {
        util.showDataDialog({controller: 'TeamSportDivisionDataCtrl', item: division});
    };

    $scope.removeDivision = function(division) {
        confirm.show('Are you sure you want to remove the division?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/division/remove', null, {id: division.id}, 'Division removed', 'Failed to remove division').then(resolve);
        });
    };

    $scope.registerTeam = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamRegisterCtrl',
            resolve: {
                gameclass: function() {
                    return $scope.gameclass;
                },
                division: function() {
                    return $scope.teamsConfig.control.getActiveTab ? $scope.teamsConfig.control.getActiveTab().context : $scope.division;
                }
            }
        });
    };

    $scope.showMatch = function(match) {
        $location.path('/teamsports/match/' + match.id);
    };

    $scope.registerTeams = function() {
        $modal.open({
            templateUrl: 'views/getamountmodal.html',
            controller: 'AmountCtrl',
            resolve: {
                amount: function() { return 100; },
                option: function() { return {};}
            }
        }).result.then(function (amount) {
            console.log('Adding ' + amount + ' registrations');
            server.post('/api/teamsport/team/test/multiadd', {gameclass_id: $scope.gameclass.id, count: amount});
        });
    };

    $scope.changeTeam = function(team) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamChangeCtrl',
            resolve: {
                team: function() {
                    return team;
                },
                division: function() {
                    return $scope.teamsConfig.control.getActiveTab ? $scope.teamsConfig.control.getActiveTab().context : $scope.division;
                },
                gameclass: function() {
                    return $scope.gameclass;
                }
            }
        });
    };

    var payment_status;
    function getPaymentStatus() {
        server.get('/api/teamsport/gameclass/payment/status', {gameclass_id: $routeParams.gameclassId}).then(function(result) {
            payment_status = result;
            if ($scope.teamsConfig && $scope.teamsConfig.control) {
                $scope.teamsConfig.control.update();
            }
        });
    }
    getPaymentStatus();

    $scope.removeTeam = function(team) {
        $modal.open({
            templateUrl: '/views/removeteam.html',
            controller: 'TeamRemoveModalCtrl',
            resolve: {
                options: function() {
                    return {team: team};
                }
            }
        });
    };

    $scope.showRegistration = function(team) {
        $modal.open({
            templateUrl: 'views/teamsportregistration.html',
            controller: 'TeamRegistrationModalCtrl',
            resolve: {
                team: function() {
                    return team;
                },
                payments: function() {
                    var ps = payment_status[team.id];
                    return ps && ps.payments;
                }
            }
        });
    };

    $scope.setReferee = function(division) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SetRefereeCtrl',
            resolve: {
                division: function() {
                    return division;
                }
            }
        });
    };

    $scope.moveTeams = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MoveTeamsCtrl',
            resolve: {
                gameclass: function() {
                    return $scope.gameclass;
                },
                division: function() {
                    return $scope.teamsConfig.control.getActiveTab ? $scope.teamsConfig.control.getActiveTab().context : $scope.gameclass.divisions[0];
                }
            }
        });
    };

    $scope.createMatches = function(division, step) {
        $modal.open({
            templateUrl: 'views/creatematches.html',
            controller: 'TeamSportCreateMatchesCtrl',
            resolve: {
                options: function() {
                    return {
                        competition: $scope.gameclass.competition,
                        division: division,
                        step: step
                    };
                }
            }
        });
    };

    $scope.addWatcher = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            controller: 'GetCustomerCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return {
                        itemFilter: function(user) {
                            return !$scope.gameclass.watchers.find(function(w) {
                                return w.user_id == user.id;
                            });
                        }
                    };
                }
            }
        });

        modalInstance.result.then(function (customer) {
            server.post('/api/teamsport/watch/add', null, {gameclass_id: $scope.gameclass.id, user_id: customer.id});
        });
    };

    function compareDivision(a, b) {
        return a.name.localeCompare(b && b.name);
    }

    function buildDivisionTabs(divisions) {
        var tabs = $filter('orderBy')(divisions.filter(function(d) { return d.competitionstep.registration; }), undefined, undefined, compareDivision).map(function(d) {
            return { name: d.name, badgeClass: 'badge-success', itemFilter: function(team) { return _.findWhere(d.teams, {id: team.id}); }, context: d };
        });

        var has_division = function(team) {
            return !!_.find(tabs.filter(function(tab) { return tab.context;}), function(tab) {
                return tab.itemFilter(team);
            });
        };

        tabs.push({name: 'No division', badgeClass: 'badge-danger', itemFilter: function(team) { return !has_division(team); }, context: null });
        return tabs;
    }

    function getPaymentStatusForTeam(team) {
        if (payment_status) {
            var ps = payment_status[team.id];
            if (ps) {
                return $filter('translate')(ps.paid ? 'Paid' : 'UNPAID_ONE');
            }
        }
    }

    $scope.sendMailing = function() {
        $modal.open({
            templateUrl: 'views/teamsportsendmailingmodal.html',
            controller: 'TeamSportSendMailingCtrl',
            resolve: {
                competitionIds: function() {
                    return null;
                }
            }
        });
    };

    $scope.removeMatches = function(division) {
        server.get('/api/teamsport/match/has_played', {division_id: division.id}).then(function(result) {
            if (result.has_played_matches) {
                alertProvider.modal('Error', 'Cannot remove all matches for a division where there are played matches');
            } else {
                confirm.show('Are you sure you want to remove all matches?', {ladda: true}).then(function(resolve) {
                    server.post('/api/teamsport/division/removematches', null, {id: division.id}).then(resolve);
                });
            }
        });
    };

    var competitionStepRemoveMatches = function(step) {
        server.get('/api/teamsport/match/has_played', {competitionstep_id: step.id}).then(function(result) {
            if (result.has_played_matches) {
                alertProvider.modal('Error', 'Cannot remove all matches for a division where there are played matches');
            } else {
                confirm.show('Are you sure you want to remove all matches?', {ladda: true}).then(function(resolve) {
                    server.post('/api/teamsport/competitionstep/removematches', null, {id: step.id}).then(resolve);
                });
            }
        });
    };

    function showBooker() {
        return $scope.gameclass?.canBookFor != 'self';
    }

    function createTeamsConfig() {
        if (!$scope.gameclass) {
            return;
        }
        var divisions = $scope.divisions || [];

        $scope.teamsConfig = {
            getItems: function() {
                return $scope.gameclass.teams;
            },
            countSuffixList: $scope.gameclass.individual ? ['person', 'persons'] : ['team', 'teams'],
            giveFocus: function() { return false; },
            tabs: buildDivisionTabs(divisions),
            rowClick: $scope.showRegistration,
            orderColumn: 'name',
            columns: [
                {field: 'image', title: '', src: teamsportutil.getImage },
                {field: 'name', title: 'Name'},
                {field: 'booker.name', title: 'Booker', visible: showBooker },
                {field: 'created', title: 'Registration date', format: 'date' },
                {field: 'group.users', title: 'Number of team members', visible: function() { return !$scope.gameclass.individual; }, format: 'count' },
                {field: 'payment_status', title: 'Payment status', visible: function() { return Number($scope.gameclass.price) > 0; }, getValue: getPaymentStatusForTeam }
            ],
            searchButtons: [
                {title: ($scope.gameclass.individual ? 'Register' : 'Register team'), onClick: $scope.registerTeam, showOnEmpty: true},
                {title: 'Move registrations', buttonClass: 'btn-warning', onClick: $scope.moveTeams, showOnEmpty: true},
                {title: 'Send mailing', onClick: $scope.sendMailing},
            ],
            buttons: [
                { title: 'Show registration', buttonClass: 'btn-success', onClick: $scope.showRegistration },
                { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeTeam },
                { title: 'Remove', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.removeTeam }
            ]
        };

        ($scope.gameclass.questions || []).forEach(function(q) {
            var col = {field: 'registration_answers.' + q.name, title: q.name, splitted_name: ['registration_answers', q.name]};
            $scope.teamsConfig.columns.push(col);
        });

        if ($scope.gameclass.one_match && divisions.length == 1 && divisions[0].matches.length == 1) {
            $scope.oneMatchConfig.match_id = divisions[0].matches[0].id;
        }

        if ($scope.gameclass.one_match && divisions.length == 1) {
            $scope.division = divisions[0];
        }
    }

    $scope.assignTimes = function(division, competitionstep) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'AssignTimesCtrl',
            resolve: {
                options: function() {
                    return {
                        competition: $scope.gameclass.competition,
                        division: division,
                        competitionstep: competitionstep
                    };
                }
            }
        });
    };

    var removeMatchTimes = function(filter) {
        confirm.show('Are you sure you want to remove all match times?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/times/remove', filter, null, 'Match times removed', 'Failed to remove match times').then(resolve);
        });
    };

    $scope.watchingConfig = {
        getItems: function() {
            return $scope.gameclass?.watchers || [];
        },
        countSuffixList: ['watcher', 'watchers'],
        giveFocus: function() { return false; },
        orderColumn: 'name',
        columns: [
            {field: 'image', title: ''},
            {field: 'name', title: 'Name'},
        ],
        searchButtons: [
            {title: 'Add', onClick: $scope.addWatcher, showOnEmpty: true }
        ],
        buttons: [
            { title: 'Remove', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: function(user) {
                confirm.show('Are you sure you want to remove the watcher?', {ladda: true}).then(function(resolve) {
                    server.post('/api/teamsport/watch/remove', null, {gameclass_id: $scope.gameclass.id, user_id: user.id}, 'Watcher removed', 'Failed to remove watcher').then(resolve);
                }
            );} }
        ]
    };

    $scope.divisionsConfig = {
        api: {
            url: '/api/teamsport/division/get_compact',
            args: {
                gameclass_id: $routeParams.gameclassId
            },
            triggers: [{type: 'teamsportdivision'}, {type: 'competitionstep', condition: function(step) { return step.gameclass_id == $routeParams.gameclassId; }}],
            onItemsUpdated: function(divisions) {
                $scope.divisions = divisions;
                createTeamsConfig();
            }
        },
        countSuffixList: ['division', 'divisions'],
        rowClick: function(d) {
            $location.path('/teamsports/division/' + d.id);
        },
        giveFocus: function() { return false; },
        orderColumn: 'name',
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'matches', title: 'Matches', format: 'count' }
        ],
        searchButtons: [
            {title: 'Add', onClick: $scope.addDivision, showOnEmpty: true, visible: function() {return $scope.gameclass && $scope.gameclass.steps.length;} }
        ],
        buttons: [
            { title: 'Create matches', buttonClass: 'btn-success', visible: function(division) { return !division.matches_created && division.num_teams; }, onClick: $scope.createMatches },
            { title: 'Assign times', buttonClass: 'btn-success', visible: function(division) { return division.matches_created && !division.times_assigned; }, onClick: $scope.assignTimes },
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeDivision },
            { title: 'Set referee', buttonClass: 'btn-info', visible: function(division) { return division.number_assigned_times && $rootScope.hasPermission('Competition handling'); }, onClick: $scope.setReferee },
            { title: 'Remove matches', buttonClass: 'btn-danger', onClick: $scope.removeMatches, visible: function(division) {return division.matches_created && !division.number_assigned_times && !division.has_played;} },
            { title: 'Remove match times', buttonClass: 'btn-danger', onClick: function(division){removeMatchTimes({division_id: division.id});}, visible: function(division) {return division.number_assigned_times && !division.has_played;} },
            { title: 'Remove', buttonClass: 'btn-danger', visible: function(division) { return !division.matches_created && !division.number_assigned_times && !division.has_played; }, onClick: $scope.removeDivision }
        ]
    };

    $scope.addStep = function() {
        util.showDataDialog({controller: 'CompetitionStepDataCtrl', data: {gameclass: $scope.gameclass}, initial: {gameclass_id: $scope.gameclass.id} });
    };

    $scope.changeStep = function(step) {
        util.showDataDialog({controller: 'CompetitionStepDataCtrl', item: step, data: {gameclass: $scope.gameclass}});
    };

    $scope.removeStep = function(step) {
        confirm.show('Are you sure you want to remove the step?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/competitionstep/remove', null, {id: step.id}, 'Step removed', 'Failed to remove step').then(resolve);
        });
    };

    $scope.createCup = function() {
        util.waitFor($scope, function() { return $scope.gameclass; }).then(function() {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'CreateCupCtrl',
                resolve: {
                    gameclass: function() {
                        return $scope.gameclass;
                    }
                }
            });
        });
    };

    $scope.stepsConfig = {
        api: {
            url: '/api/teamsport/competitionstep/get',
            args: {
                gameclass_id: $routeParams.gameclassId
            },
            triggers: [{type: 'competitionstep'}]
        },
        giveFocus: function() { return false; },
        countSuffixList: ['step', 'steps'],
        columns: [
            {field: 'name', title: 'Name'}
        ],
        searchButtons: [
            {title: 'Add', onClick: $scope.addStep, showOnEmpty: true },
            {title: 'Create cup', onClick: $scope.createCup, showOnEmpty: true }
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeStep },
            {title: 'Create matches', onClick: function(step) {$scope.createMatches(null, step);}, visible: function(step) {return step.able_create_matches;} },
            {title: 'Assign times', onClick: function(step) {$scope.assignTimes(null, step);}, visible: function(step) {return step.able_assign_times;} },
            {title: 'Remove', buttonClass: 'btn-danger', visible: function(step) { return step.able_remove; }, onClick: $scope.removeStep },
            {title: 'Remove matches', buttonClass: 'btn-danger', onClick: competitionStepRemoveMatches, visible: function(step) {return step.able_remove_matches;} },
            {title: 'Remove match times', buttonClass: 'btn-danger', onClick: function(step) {removeMatchTimes({competitionstep_id: step.id});}, visible: function(step) {return step.able_remove_times;} }
        ],
        rowClick: function(step) {
            $location.path('/teamsports/step/' + step.id);
        }
    };

    function twoTeams() {
        return $scope.matchesConfig.twoTeams;
    }

    function hasName() {
        return $scope.matchesConfig.hasName;
    }

    function showDivision() {
        return $scope.divisions && $scope.divisions.length > 1;
    }

    function getDivisionName(f) {
        var d = _.findWhere($scope.divisions, {id: f.division_id});
        return d && d.name;
    }

    $scope.setResult = function(match) {
        server.get('/api/teamsport/match/get', {id: match.id}).then(function(match) {
            $modal.open({
                templateUrl: 'views/changemodal.html',
                controller: 'TeamMatchSetResultCtrl',
                resolve: {
                    match: function() {
                        return teamsportutil.transformMatch(match);
                    }
                }
            });
        });
    };

    $scope.changeMatch = function(match) {
        server.get('/api/teamsport/match/get', {id: match.id}).then(function(match) {
            $modal.open({
                templateUrl: 'views/changemodal.html',
                controller: 'TeamMatchChangeCtrl',
                resolve: {
                    match: function() {
                        return teamsportutil.transformMatch(match);
                    }
                }
            });
        });
    };

    $rootScope.waitFor(['members', 'usergroups']).then(function() {
        $scope.matchesConfig = {
            api: {
                url: '/api/teamsport/match/overview',
                args: {
                    gameclass_id: $routeParams.gameclassId,
                    result: true
                },
                transform: function(m) {
                    m.startTime = Date.newFull(m.startTime);
                    $rootScope.updatePointersById(m.resources, $rootScope.members);
                    m.teams.forEach(function(team) {
                        team.group = $rootScope.getPointerById(team.group_id, $rootScope.usergroups);
                    });
                    return m;
                },
                triggers: [
                    {
                        type: 'teamsportmatch',
                        condition: function(match) { return !match.gameclass_id || match.gameclass_id == $routeParams.gameclassId; }
                    },
                    {
                        type: 'teamsportgameclass',
                        condition: gameclass => gameclass.id == $routeParams.gameclassId
                    }
                ],
                onItemsUpdated: function(items) {
                    $scope.matchesConfig.twoTeams = !_.find(items, function(m) { return m.teams.length != 2; });
                    $scope.matchesConfig.hasName = _.find(items, function(m) { return m.name; });
                    $scope.matchesConfig.control.rebuild();
                }
            },
            countSuffixList: ['match', 'matches'],
            rowClick: $scope.showMatch,
            giveFocus: function() { return false; },
            searchDepth: 3,
            orderColumn: 'startTime',
            columns: [
                { field: 'startTime', title: 'Start time', format: 'datetimeshort' },
                { field: 'name', title: 'Name', visible: function() { return hasName(); } },
                { field: 'division', title: 'Division', visible: function() { return showDivision(); }, getValue: getDivisionName },
                {field: 'home_team', title: 'Home team', format: 'image', text: function(m) { return m.teams.length ? m.teams[0].name : '';}, src: function(m) { return m.teams.length ? teamsportutil.getImage(m.teams[0]) : null; }, size: function() { return '50px'; } },
                {field: 'away_team', title: 'Away team', format: 'image', text: function(m) { return m.teams.length > 1 ? m.teams[1].name : '';}, src: function(m) { return m.teams.length ? teamsportutil.getImage(m.teams[1]) : null; }, size: function() { return '50px'; } },
                { field: 'location', title: 'Location', getValue: util.getRoomAndLocation},
                { field: 'teams', title: 'Number of teams', format: 'count', visible: function() { return !twoTeams(); } },
                { field: 'result', title: 'Result' }
            ],
            buttons: [
                { title: 'Set result', buttonClass: 'btn-success', visible: function(match) { return $rootScope.hasPermission('Competition handling') && !match.finished; }, onClick: $scope.setResult },
                { title: 'Change result', buttonClass: 'btn-warning', visible: function(match) { return $rootScope.hasPermission('Competition handling') && match.finished; }, onClick: $scope.setResult },
                { title: 'Change', buttonClass: 'btn-warning', visible: function(match) { return !match.finished && $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeMatch }
            ]
        };
    });

    $scope.oneMatchConfig = {
        match_id: $scope.match_id
    };

    function fetchCombinedTable() {
        if (!$scope.combinedSteps || !$scope.combinedSteps.length) {
            $scope.combinedtableconfig = null;
            return;
        }
        server.get('/api/teamsport/result/for_gameclass', {gameclass_id: $routeParams.gameclassId}).then(function(data) {
            $scope.combinedtableconfig = (data.rows && data.rows.length) ? teamsportutil.buildTable(data) : null;
        }).catch(function() {
            $scope.combinedtableconfig = null;
        });
    }

    $scope.combinedStepOptions = [];
    $scope.combinedStepsSelected = {};

    $scope.saveCombinedSteps = function() {
        var ids = ($scope.combinedStepOptions || []).filter(function(s) { return $scope.combinedStepsSelected[s.id]; }).map(function(s) { return s.id; });
        server.post('/api/teamsport/gameclass/change', {id: $scope.gameclass.id, combined_steps: ids}, null, 'Changes saved', 'Could not save').then(function() {
            $scope.combinedSteps = ids;
            fetchCombinedTable();
        });
    };

    function fetchGameClass() {
        server.get('/api/teamsport/gameclass/get', {id: $routeParams.gameclassId}).then(function(data) {
            $scope.gameclass = teamsportutil.transformGameClass(data);
            $scope.combinedSteps = data.combined_steps || [];
            $scope.combinedStepsSelected = {};
            $scope.combinedSteps.forEach(function(id) { $scope.combinedStepsSelected[id] = true; });
            createTeamsConfig();
            fetchCombinedTable();
        });
        server.get('/api/teamsport/competitionstep/get', {gameclass_id: $routeParams.gameclassId}).then(function(steps) {
            $scope.combinedStepOptions = steps || [];
        });
    }
    fetchGameClass();

    live.subscribe( {
        type: 'teamsportgameclass',
        scope: $scope,
        callback: function(g) {
            if (g.id == $routeParams.gameclassId) {
                fetchGameClass();
            }
        }
    });


    live.subscribe( {
        type: 'competitionstep',
        scope: $scope,
        callback: function(step) {
            if (step.gameclass_id == $routeParams.gameclassId) {
                fetchGameClass();
            }
        }
    });

    live.subscribe( {
        type: 'teamsportmatch',
        scope: $scope,
        callback: function(match) {
            // Only refetch when the changed match belongs to one of this game
            // class' divisions (the match payload has no gameclass_id), so an
            // unrelated tenant-wide match change doesn't trigger a request.
            if (match && _.findWhere($scope.divisions || [], {id: match.division_id})) {
                fetchCombinedTable();
            }
        }
    });

    live.subscribe( {
        type: 'payment',
        scope: $scope,
        callback: function() {
            getPaymentStatus();
        }
    });

    if (window.createcup) {
        window.createcup = undefined;
        $scope.createCup();
    }
}]);

teamsports.controller('TeamRegistrationModalCtrl', ['$rootScope', '$scope', 'server', 'util', 'team', 'payments', function($rootScope, $scope, server, util, team, payments) {
    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        $rootScope.gotoCustomer(customer);
    };
    $scope.team = team;
    $scope.payments = payments || [];

    $scope.paymentsConfig = {
        getItems: function() {
            return payments;
        },
        tabs: [
            {name: 'Unpaid', badgeClass: 'badge-danger', itemFilter: function(p) { return p.status != 'paid'; } },
            {name: 'Paid', badgeClass: 'badge-success', itemFilter: function(p) { return p.status == 'paid'; } }
        ],
        rowClick: function(p) {
            $rootScope.gotoCustomer(p.payer_id);
            $scope.$close();
        },
        columns: [
            {field: 'image', title: '', src: function(p) { return $rootScope.smallMemberImage($rootScope.getMember(p.payer_id)); } },
            {field: 'name', title: 'Name', getValue: function(p) { return $rootScope.getMember(p.payer_id).name; } },
            {field: 'amount', title: 'Amount', format: 'price'}
        ],
        hideSearch: true,
        hideEmptyTabs: true,
        onInit: function() {
            if (payments.filter(function(p) { return p.status != 'paid'; }).length == 0) {
                $scope.paymentsConfig.control.setActiveTab($scope.paymentsConfig.tabs[1]);
            }
        }
    };

    if (team.registration_answers) {
        server.get('/api/teamsport/gameclass/get', {id: team.gameclass_id}).then(function(data) {
            $scope.fields = [];
            util.addQuestions($scope.fields, data.questions, '');

            $scope.fields.forEach(function(field) {
                field.readonly = true;
                if (field.type == 'text' || field.type == 'number') {
                    field.type = 'label';
                }

                var value = team.registration_answers[field.name];
                if (field.type == 'select') {
                    if (value) {
                        field.value = _.findWhere(field.options(), {id: value});
                    }
                } else if (field.type == 'multiselect') {
                    if (value && Array.isArray(value)) {
                        field.value = value.map(function(item) {
                            return _.findWhere(field.options(), {id: item});
                        });
                    }
                } else {
                    field.value = value;
                }
            });
        });
    }

}]);

teamsports.controller('TeamChangeCtrl', ['$rootScope', '$scope', '$controller', 'team', 'gameclass', '$filter', 'division', function($rootScope, $scope, $controller, team, gameclass, $filter, division) {
    $controller('TeamRegisterCtrl', {$scope: $scope, gameclass: gameclass, division: division});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('registration for') + ' ' + team.name;
    };

    $scope.item = team;

    $scope.postUrl = '/api/teamsport/team/change';
}]);

teamsports.controller('TeamRegisterCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'gameclass', 'division', 'util', '$q', function($rootScope, $scope, $controller, $filter, server, gameclass, division, util, $q) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Register';
    $scope.titleSuffix = function() {
        if (!gameclass.individual) {
            return $filter('translate')('team');
        }
    };

    $scope.postUrl = '/api/teamsport/team/add';

    function getField(name) {
        return _.findWhere($scope.fields, {name: name});
    }

    $scope.callCloseOnSuccess = true;
    $scope.selectedGameClass = null;
    function getGameClass() {
        return $scope.selectedGameClass;
    }
    function getGameClassId() {
        var gc = _.findWhere($scope.fields, {name: 'gameclass_id'});
        return gc && gc.value && gc.value.id;
    }

    function isVacant() {
        var vacant = _.findWhere($scope.fields, {name: 'vacant'}).value;
        return vacant;
    }

    function addQuestions() {
        $scope.fields = $scope.fields.filter(function(field) { return !field.name || field.name.indexOf('registration_answers') == -1; });
        util.addQuestions($scope.fields, getGameClass().questions, 'registration_answers');

        $scope.fields.forEach(function(field) {
            if(!field.name || !field.name.startsWith('registration_answers.')) {return;}
            field.visible = function() {
                return !isVacant();
            };
        });
    }

    $scope.divisions = [];
    function fetchGameClass() {
        $scope.selectedGameClass = null;
        return $q.promise(function(resolve, reject) {
            var id = getGameClassId();
            if(id) {
                server.get('/api/teamsport/gameclass/get_compact_one', {id: id}).then(function(gameclass) {
                    $scope.selectedGameClass = gameclass;
                    $scope.divisions = gameclass.divisions;
                    addQuestions();
                    resolve();
                }, reject);
            } else {
                reject();
            }
        });
    }

    function getGameclasses() {
        server.get('/api/teamsport/gameclass/get_compact_list', {competition_id: gameclass.competition_id}).then(function(gameclasses) {
            $scope.gameclasses = gameclasses.filter(function(gc) { return gc.individual == gameclass.individual && gc.one_match == gameclass.one_match; });
            $scope.gameclasses.forEach(function(gc) {
                gc.competition = gameclass.competition;
            });

            _.findWhere($scope.fields, {name: 'gameclass_id'}).value = _.findWhere($scope.gameclasses, {id: gameclass.id});
            fetchGameClass().then(function() {
                if ($scope.item) {
                    $scope.item.group_id = $scope.item.group && $scope.item.group.id;
                    if(division) {$scope.item.division_id = division.id;}
                    $scope.setValues($scope.item);
                } else {
                    var f = getField('division_id');
                    f.value = _.findWhere(f.options(), {id: division.id});
                }
            });
        });
    }
    getGameclasses();

    function gameClassChanged() {
        _.findWhere($scope.fields, {name: 'division_id'}).value = null;
        fetchGameClass();
    }

    function getDivisions() {
        return $scope.divisions;
    }

    function isGameClassChanged() {
        return getGameClassId() != gameclass.id;
    }

    function isFull() {
        var gc = getGameClass();
        return (!$scope.item || isGameClassChanged()) && gc && gc.max_number_of_teams && gc.teams.length >= gc.max_number_of_teams;
    }

    function isRegistered(group) {
        var gc = getGameClass();
        return !!_.find(gc.teams, function(tr) {
            return (tr.group && tr.group.id) == (group && group.id);
        });
    }

    function showGroupChangeWarning() {
        var g = _.findWhere($scope.fields, {name: 'group_id'});
        return $scope.item && g.visible() && g.value && $scope.item.group_id != g.value.id && !isRegistered(g.value);
    }

    function groupFilter(group) {
        var gc = getGameClass();
        if (!gc || group.teamsport_id && group.teamsport_id != gc.competition.teamsport_id) {
            return false;
        }

        var vacant = $scope.item && $scope.item.group == null;

        return vacant || !isRegistered(group);
    }

    function individualNotRegistered(customer) {
        var gc = getGameClass();
        return !_.find(gc.teams, function(tr) {
            return tr.user_id == customer.id;
        });
    }

    function isReplacingVacantTeam() {
        var vacant = $scope.item && $scope.item.group == null;
        var g = _.findWhere($scope.fields, {name: 'group_id'});
        return g && g.visible() && g.value && vacant && isRegistered(g.value);
    }

    function okTeamName() {
        var gc = getGameClass();
        if (!gc) {
            return true;
        }

        if (isReplacingVacantTeam()) {
            return true;
        }

        var name = _.findWhere($scope.fields, {name: 'name'}).value;
        return !_.find(gc.teams.filter(function(t) { return !$scope.item || t.id != $scope.item.id; }), function(tr) {
            return tr.name == name;
        });
    }

    $scope.canSubmit = function() {
        if (isFull() || !okTeamName()) {
            return false;
        }

        return true;
    };

    function hasGroup() {
        return _.findWhere($scope.fields, {name: 'group_id'}).value;
    }

    function hasCustomer() {
        return _.findWhere($scope.fields, {name: 'user_id'}).value;
    }

    function setTeamName() {
        var gc = getGameClass();
        var p = gc.individual ? 'user_id' : 'group_id';
        var g = _.findWhere($scope.fields, {name: p}).value;
        if (!g) {
            return;
        }
        if (gc.individual && $rootScope.speedy) {
            // In speedy mode the picked customer is a lazily-loaded placeholder whose
            // name is still "Loading..." when this change fires, so copying it verbatim
            // would leave the name field stuck on that text. Resolve the member first.
            var selectedId = g.id;
            // Apply a resolved name only while this customer is still the selected one,
            // so a late response can't overwrite a newer (or cleared) selection.
            var stillSelected = function() {
                var current = _.findWhere($scope.fields, {name: 'user_id'}).value;
                return current && current.id === selectedId;
            };
            $rootScope.getMembersAsync([selectedId]).then(function(members) {
                var member = members && members[0];
                if (member && stillSelected()) {
                    _.findWhere($scope.fields, {name: 'name'}).value = member.name;
                }
            }).catch(function() {
                // Resolution failed; fall back to the placeholder object's name rather
                // than leaving the field stuck on "Loading...".
                if (stillSelected()) {
                    _.findWhere($scope.fields, {name: 'name'}).value = g.name;
                }
            });
        } else {
            _.findWhere($scope.fields, {name: 'name'}).value = g.name;
        }
    }

    function hasPrice() {
        var gc = getGameClass();
        return gc && gc.product_id && Number(gc.price) > 0;
    }

    function isTeamMember(u) {
        var users = _.findWhere($scope.fields, {name: 'group_id'}).value.users;
        var inlist = users.indexOf(u) != -1 || users.indexOf(u.id) != -1;
        return inlist;
    }

    function setPayer() {
        if (hasPrice()) {
            var gc = getGameClass();
            if (gc.individual) {
                _.findWhere($scope.fields, {name: 'payer_id'}).value = _.findWhere($scope.fields, {name: 'user_id'}).value;
            } else {
                $rootScope.getGroupAsync(_.findWhere($scope.fields, {name: 'group_id'}).value.id).then(group => {
                    let responsible = group.responsible;
                    _.findWhere($scope.fields, {name: 'payer_id'}).value = responsible.length ? $rootScope.getMember(responsible[0]) : null;
                });
            }
        }
    }

    function groupOrCustomerChanged() {
        setTeamName();
        setPayer();
    }

    function addGroup() {
        util.showDataDialog({controller: 'UserGroupDataCtrl'}).result.then(function(group) {
            var g = _.findWhere($scope.fields, {name: 'group_id'});
            util.waitForNewObject(group.id, function(id) { return _.findWhere(g.options(), {id: id}); }, 'usergroup').then(function(group) {
                g.value = group;
                groupOrCustomerChanged();
            });
        });
    }

    let groupRow;
    if ($rootScope.speedy) {
        groupRow = {name: 'group_id', title: 'Team', required: true, type: 'group', useId: true, itemFilter: groupFilter, searchFilters: function() { var gc = getGameClass(); return gc ? {teamsport_id: gc.competition.teamsport_id} : null; }, visible: function() { return getGameClass() && !getGameClass().individual && !isVacant(); }, addButtonClicked: addGroup, addButtonTitle: 'Add', change: groupOrCustomerChanged};
    } else {
        groupRow = {name: 'group_id', title: 'Team', type: 'select', required: true, useId: true, options: function() { return $rootScope.usergroups; }, skipTranslation: true, optionsFilter: groupFilter, visible: function() { return getGameClass() && !getGameClass().individual && !isVacant(); }, addButtonClicked: addGroup, addButtonTitle: 'Add', change: groupOrCustomerChanged }
    }

    $scope.fields = [
        {name: 'gameclass_id', title: 'Game class', type: 'select', required: true, readonly: false, useId: true, options: function() {return $scope.gameclasses; }, change: gameClassChanged },
        {hint: 'GAMECLASS_CHANGED', hintClass: 'alert-danger', visible: isGameClassChanged },
        {hint: 'No more teams can be registered', hintClass: 'alert-danger', visible: isFull },
        {name: 'division_id', title: 'Division', type: 'select', required: false, readonly: false, useId: true, options: getDivisions, visible: function() { return  getGameClass() && !getGameClass().one_match; } },
        {name: 'vacant', title: 'Vacant spots', type: 'number', required: false, min: 1, visible: function() { return !$scope.item; } },
        groupRow,
        {hint: 'GROUP_CHANGED', hintClass: 'alert-danger', visible: showGroupChangeWarning },
        {name: 'user_id', title: 'Customer', type: 'customer', required: true, useId: true, visible: function() { return (!$scope.item || !$scope.item.user_id) && getGameClass() && getGameClass().individual && !isVacant(); }, itemFilter: individualNotRegistered, change: groupOrCustomerChanged },
        {name: 'name', title: (gameclass.individual ? 'Name' : 'Team name'), type: 'text', required: true, visible: function() { return $scope.item || (getGameClass() && getGameClass().individual && hasCustomer()) || (getGameClass() && !getGameClass().individual && hasGroup()); } },
        {name: 'payer_id', title: 'Payer', type: 'customer', required: true, visible: function() { return !$scope.item && hasPrice() && !isVacant(); }, itemFilter: function(customer) { return gameclass.individual ? true : isTeamMember(customer); } }
    ];
}]);

teamsports.controller('TeamMatchChangeCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'match', 'teamsportutil', 'server', 'confirm', '$location', '$modal', 'util', function($rootScope, $scope, $controller, $filter, match, teamsportutil, server, confirm, $location, $modal, util) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    var relevantFieldChanged = false;
    var preChangeParticipants = [];

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        var origActivity = match.activity || {};

        var toTime = function(d) { var t = Date.newFull(d); return t ? t.getTime() : null; };
        var toIds = function(arr) {
            return (arr || []).map(function(x) { return _.isObject(x) ? x.id : x; });
        };

        var timeChanged = toTime(item.activity && item.activity.startTime) !== toTime(origActivity.startTime);
        var resourcesChanged = !util.arraysEqual(item.activity && item.activity.resources || [], toIds(origActivity.resources));
        var teamsChanged = !util.arraysEqual(item.teams || [], toIds(match.teams));

        relevantFieldChanged = timeChanged || resourcesChanged || teamsChanged;

        if (teamsChanged) {
            server.get('/api/teamsport/match/participants', {id: match.id}).then(function(result) {
                preChangeParticipants = result || [];
                $scope.doSubmit(item);
            });
        } else {
            $scope.doSubmit(item);
        }
    };

    $scope.possiblyClose = function(data) {
        if (relevantFieldChanged) {
            server.get('/api/teamsport/match/participants', {id: match.id}).then(function(result) {
                $scope.$close(data);
                var allUsers = _.union(preChangeParticipants, result || []);
                if (allUsers.length) {
                    $modal.open({
                        templateUrl: 'views/message.html',
                        controller: 'MatchSendMessageCtrl',
                        resolve: {
                            users: function() { return allUsers; }
                        }
                    });
                }
            }).catch(function() {
                $scope.loadingStatus.loading = false;
                $scope.$close(data);
            });
        } else {
            $scope.$close(data);
        }
    };

    $scope.titleSuffix = function() {
        return teamsportutil.getMatchName(match);
    };

    server.get('/api/teamsport/scoring/get').then(function(result) {
        $scope.scoring = result;
    });

    var teams = [];

    function moreTeam(field) {
        delete field.addButtonClicked;
        server.get('/api/teamsport/gameclass/get', {id: match.gameclass_id}).then(function(result) {
            teams = result.teams;
        });
    }

    server.get('/api/teamsport/division/get', {id: match.division_id}).then(function(result) {
        teams = result.teams;

        var reloadFromGameClass = false;
        match.teams.forEach(function(t) {
            var ok = false;
            for(var i=0;i<teams.length;i++) {
                if(teams[i].id === t.id) {
                    ok = true;
                    break;
                }
            }
            if(!ok) {
                reloadFromGameClass = true;
            }
        });

        if(reloadFromGameClass) {
            moreTeam(_.findWhere($scope.fields, {name: 'teams'}));
        }
    });

    $scope.item = match;

    $scope.postUrl = '/api/teamsport/match/change';

    $scope.callCloseOnSuccess = true;

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: false },
        {name: 'result_type', title: 'Result type', type: 'select', required: true, options: function() { return teamsportutil.resulttypes; }, useId: true  },
        {name: 'number_of_attempts', title: 'Number of attempts', helpText: 'NUMBER_OF_ATTEMPTS_HELPTEXT', type: 'number', required: false, min: 1 },
        {name: 'unit', title: 'Unit', helpText: 'UNIT_HELPTEXT', type: 'text', required: false, placeholder: 'm, s, kg, ...' },
        {name: 'activity.startTime', title: 'Start time', type: 'datetime', required: false },
        {name: 'activity.endTime', title: 'End time', type: 'datetime', required: false },
        {name: 'activity.resources', title: 'Rooms and locations', required: false, type: 'customers', useId: true, itemTypes: ['resource']},
        {name: 'teams', title: (match.individual ? 'Participants' : 'Teams'), type: 'multiselect', required: true, options: function() { return teams; }, useId: true, version: 2, getName: function(x) { return x.name;}, addButtonClicked: moreTeam, addButtonTitle: 'More' },
    ];

    $scope.showRemoveButton = function() {
        return true;
    };

    $scope.removeButtonClicked = function() {
        confirm.show($filter('translate')('Are you sure you want to remove {0}').format($scope.titleSuffix())).then(function() {
            server.get('/api/teamsport/match/participants', {id: match.id}).then(function(participants) {
                server.post('/api/teamsport/match/remove', null, {id: match.id}, 'Match removed', 'Failed to remove match').then(function() {
                    if ($scope.unsavedCheck) {
                        $scope.unsavedCheck();
                    }
                    if ($scope.listenToUrlChange) {
                        $scope.listenToUrlChange();
                    }
                    $scope.$dismiss();
                    $location.path('/teamsports/division/' + (match.division_id || match.division.id));
                    if (participants && participants.length) {
                        $modal.open({
                            templateUrl: 'views/message.html',
                            controller: 'MatchSendMessageCtrl',
                            resolve: {
                                users: function() { return participants; }
                            }
                        });
                    }
                });
            });
        });
    };

    $scope.$watch(function() { return $scope.scoring && teams; }, function(value) {
        if (value) {
            $scope.setValues($scope.item);
        }
    });
}]);

teamsports.controller('TeamMatchAddDataCtrl', ['$scope', 'server', 'teamsportutil', 'options', function($scope, server, teamsportutil, options) {
    function onSetStartTime() {
        var match_length = options.config.data.division?.match_length || options.config.data.competitionstep?.gameclass?.match_length || 60;

        var d = $scope.config.control.getField('startTime').value.clone();
        d.addMinutes(match_length);
        $scope.config.control.getField('endTime').value = d;
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'match',
        url: {
            add: '/api/teamsport/match/add'
        },
        data: {
            scoring: server.get('/api/teamsport/scoring/get'),
            divisions: [options.config.data.division]
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'division_id', title: 'Division', type: 'select', required: false, readonly: true, useId: true, options: function() { return $scope.config.data.divisions;} },
                    {name: 'name', title: 'Name', type: 'text', required: false },
                    {name: 'startTime', title: 'Start time', type: 'datetime', required: true, change: onSetStartTime },
                    {name: 'endTime', title: 'End time', type: 'datetime', required: true },
                    {name: 'teams', title: (options.config.data.division.competitionstep.gameclass.individual ? 'Participants' : 'Teams'), type: 'multiselect', required: true, options: function() { return $scope.config.data.division.teams; }, useId: true, version: 2, getName: function(x) { return x.name;} },
                    {name: 'resources', title: 'Rooms and locations', required: false, type: 'customers', useId: true, itemTypes: ['resource']}
                ]
            },
            {
                name: 'Advanced',
                fields: [
                    {name: 'result_type', title: 'Result type', type: 'select', required: true, options: function() { return teamsportutil.resulttypes; }, useId: true  },
                    {name: 'highest_is_best', title: 'Highest is best', type: 'checkbox' },
                    {name: 'number_of_attempts', title: 'Number of attempts', helpText: 'NUMBER_OF_ATTEMPTS_HELPTEXT', type: 'number', required: false, min: 1 },
                    {name: 'unit', title: 'Unit', helpText: 'UNIT_HELPTEXT', type: 'text', required: false, placeholder: 'm, s, kg, ...' }
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    division_id: $scope.config.data.division.id,
                    result_type: _.findWhere(teamsportutil.resulttypes, {id: $scope.config.data.division.competitionstep.gameclass.competition.teamsport.default_result_type}),
                    highest_is_best: $scope.config.data.division.competitionstep.gameclass.competition.teamsport.highest_is_best,
                    number_of_attempts: $scope.config.data.division.competitionstep.gameclass.competition.teamsport.number_of_attempts,
                    unit: $scope.config.data.division.competitionstep.gameclass.competition.teamsport.unit
                };
            }
        },
        canSubmit: function() {
            var start = $scope.config.control.getField('startTime').value;
            var end = $scope.config.control.getField('endTime').value;
            return start < end;
        }
    });
}]);

teamsports.controller('TeamRemoveModalCtrl', ['$rootScope', '$scope', 'alertProvider', '$filter', 'server', 'options', function($rootScope, $scope, alertProvider, $filter, server, options) {
    $scope.loadingStatus = {};
    var payment_status;
    var num_old_matches;
    var num_future_matches;
    $scope.initialized = false;

    function setFields() {
        $scope.fields = [
            {name: 'remove_old_matches', title: $filter('translate')('Remove {0} played matches').format(num_old_matches), type: 'checkbox', visible: function() { return num_old_matches > 0; } },
            {name: 'remove_payments', title: 'Remove unpaid payments', type: 'checkbox', visible: function() { return payment_status && payment_status.payments.filter(function(p){return p.status == 'pending';}).length; }}
        ];
        $scope.initialized = true;
    }
    $scope.content = $filter('translate')('Are you sure you want to remove the registration for {0}?').format(options.team.name);

    $scope.getOldToRemove = function() {
        return num_old_matches && _.findWhere($scope.fields, {name: 'remove_old_matches'}).value ? num_old_matches : 0;
    };

    $scope.getFutureToRemove = function() {
        return num_future_matches;
    };

    $scope.hasPaidOrSentPayments = function() {
        return payment_status && payment_status.payments.filter(function(p) { return p.status == 'sent' || p.status == 'paid'; }).length > 0;
    };

    function getRemovalInfo() {
        server.get('/api/teamsport/team/remove/status', {id: options.team.id}).then(function(result) {
            payment_status = result.payment_status;
            num_old_matches = result.num_old_matches;
            num_future_matches = result.num_future_matches;
            $scope.one_match = result.one_match;
            setFields();
        });
    }
    getRemovalInfo();

    $scope.yes = function() {
        $scope.loadingStatus.loading = true;
        var remove_old_matches = _.findWhere($scope.fields, {name: 'remove_old_matches'}).value;
        var remove_payments = _.findWhere($scope.fields, {name: 'remove_payments'}).value;
        server.post('/api/teamsport/team/remove', null, {id: options.team.id, remove_old_matches: remove_old_matches, remove_payments: remove_payments}, 'Registration removed', 'Failed to remove registration').then(function(
            response) {
            if(response.data && response.data.message) {
                alertProvider.modal('Error', response.data.message);
            }
            if (response.success) {
                $scope.$close();
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };
}]);

teamsports.controller('TeamSportDivisionCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'confirm', 'server', 'live', 'util', '$routeParams', 'teamsportutil', '$location', function($rootScope, $scope, $modal, $filter, confirm, server, live, util, $routeParams, teamsportutil, $location) {
    $scope.cup = teamsportutil.cup();

    $scope.showMatch = function(match) {
        $location.path('/teamsports/match/' + match.id);
    };

    $scope.getGameClassLink = function() {
        //if (!teamsportutil.cup() || $scope.division.competitionstep.gameclass.league !== true) { // FIXME
            return '#/teamsports/gameclass/' + $scope.division.competitionstep.gameclass.id;
        //} else {
        //    return '#/teamsports/division/' + $scope.division.id;
        //}
    };

    $scope.registerTeam = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TeamRegisterCtrl',
            resolve: {
                division: function() {
                    return $scope.division;
                },
                gameclass: function() {
                    return $scope.division.competitionstep.gameclass;
                }
            }
        });
    };

    $scope.changeTeam = function(team) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamChangeCtrl',
            resolve: {
                team: function() {
                    return team;
                },
                division: function() {
                    return $scope.division;
                },
                gameclass: function() {
                    return $scope.division.competitionstep.gameclass;
                }
            }
        });
    };

    $scope.removeTeam = function(team) {
        $modal.open({
            templateUrl: '/views/removeteam.html',
            controller: 'TeamRemoveModalCtrl',
            resolve: {
                options: function() {
                    return {team: team};
                }
            }
        });
    };

    $scope.changeDivision = function(division) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamSportDivisionChangeCtrl',
            resolve: {
                division: function() {
                    return division;
                }
            }
        });
    };

    $scope.setResult = function(match) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamMatchSetResultCtrl',
            resolve: {
                match: function() {
                    return match;
                }
            }
        });
    };

    $scope.changeMatch = function(match) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamMatchChangeCtrl',
            resolve: {
                match: function() {
                    return match;
                }
            }
        });
    };

    $scope.addMatch = function() {
        util.showDataDialog({controller: 'TeamMatchAddDataCtrl', data: {division: $scope.division } });
    };

    var payment_status;
    function getPaymentStatus() {
        server.get('/api/teamsport/division/payment/status', {division_id:$routeParams.divisionId}).then(function(result) {
            payment_status = result;
            if ($scope.teamsConfig && $scope.teamsConfig.control) {
                $scope.teamsConfig.control.update();
            }
        });
    }
    getPaymentStatus();

    $scope.showRegistration = function(team) {
        $modal.open({
            templateUrl: 'views/teamsportregistration.html',
            controller: 'TeamRegistrationModalCtrl',
            resolve: {
                team: function() {
                    return team;
                },
                payments: function() {
                    var ps = payment_status[team.id];
                    return ps && ps.payments;
                }
            }
        });
    };

    function getPaymentStatusForTeam(team) {
        if (payment_status) {
            var ps = payment_status[team.id];
            if (ps) {
                return $filter('translate')(ps.paid ? 'Paid' : 'UNPAID_ONE');
            }
        }
    }

    $scope.sendMailing = function() {
        $modal.open({
            templateUrl: 'views/teamsportsendmailingmodal.html',
            controller: 'TeamSportSendMailingCtrl',
            resolve: {
                competitionIds: function() {
                    return null;
                }
            }
        });
    };

    function createTeamsConfig() {
        $scope.teamsConfig = {
            getItems: function() {
                return $scope.division && $scope.division.teams;
            },
            countSuffixList: $scope.division.competitionstep.gameclass.individual ? ['person', 'persons'] : ['team', 'teams'],
            giveFocus: function() { return false; },
            orderColumn: 'name',
            columns: [
                {field: 'image', title: '', src: teamsportutil.getImage },
                {field: 'name', title: 'Name'},
                {field: 'booker.name', title: 'Booker', visible: () => $scope.division.competitionstep.gameclass.canBookFor != 'self'},
                {field: 'created', title: 'Registration date', format: 'date' },
                {field: 'group.users', title: 'Number of team members', visible: function() { return !$scope.division.competitionstep.gameclass.individual; }, format: 'count' },
                {field: 'payment_status', title: 'Payment status', visible: function() { return Number($scope.division.competitionstep.gameclass.price) > 0; }, getValue: getPaymentStatusForTeam }
            ],
            rowClick: $scope.showRegistration,
            searchButtons: [
                {title: ($scope.division.competitionstep.gameclass.individual ? 'Register' : 'Register team'), onClick: $scope.registerTeam, showOnEmpty: true},
                {title: 'Add match', onClick: $scope.addMatch, showOnEmpty: true},
                {title: 'Send mailing', onClick: $scope.sendMailing}
            ],
            buttons: [
                { title: 'Show registration', buttonClass: 'btn-success', onClick: $scope.showRegistration },
                { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeTeam },
                { title: 'Remove', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.removeTeam }
            ]
        };
    }

    function getResult(match) {
        if (!match.result) return;
        if (teamsportutil.isSetResult(match.result_type)) {
            return match.result[0]?.result;
        }
        if (match.result.length == 2) {
            return teamsportutil.formatResult(_.findWhere(match.result, {team_id: match.teams[0].id})) + ' - ' + teamsportutil.formatResult(_.findWhere(match.result, {team_id: match.teams[1].id}));
        }
    }

    function createTopLists(toplists) {
        toplists.forEach(function(tl) {
            tl.items.forEach(function(listrow) {
                if (tl.toplist.type == 'player') {
                    listrow.item = $rootScope.getMember(listrow.id);
                    listrow.team = _.findWhere($scope.division.teams, {id: listrow.team_id});
                } else {
                    listrow.item = _.findWhere($scope.division.teams, {id: listrow.id});
                }
            });
            tl.toplist.typelist.forEach(function(tp) {
                tp.eventtype = $rootScope.getPointerById(tp.eventtype, $scope.eventtypes);
            });

            var title = tl.toplist.type == 'player' ? 'Player' : 'Team';

            tl.config = {
                getItems: function() {
                    return tl.items;
                },
                hideSearch: true,
                columns: [
                    {field: 'position', title: '#', format: 'number'},
                    {field: 'item.name', title: title, format: 'image', src: function(p) { return $rootScope.image(tl.toplist.type == 'player' ? 'Member' : 'team', tl.toplist.type == 'player' ? p.item : p.item.group); }, size: function() { return '30px'; }, text: function(i) { return i.item.name + (i.team ? '\n' + i.team.name : ''); }, linebreak: true, placeHolderUid: item => item.item.is_placeholder ? item.item.uid : null },
                    {field: 'num_matches', title: 'Matches', format: 'number', visible: function() { return tl.toplist.show_num_matches; }}
                ],
                orderColumn: 'position'
            };

            tl.toplist.typelist.forEach(function(tp, i) {
                tl.config.columns.push({field: 'et' + i, title: tp.eventtype.name, getValue: function(row) { return row.eventtypes[tp.eventtype.id]; } } );
            });
            tl.config.columns.push({field: 'points', title: 'Points'});
        });

        $scope.toplists = toplists;
    }

    function twoTeams() {
        return $scope.matchesConfig.twoTeams;
    }

    function hasName() {
        return $scope.matchesConfig.hasName;
    }

    $scope.matchesConfig = {
        api: {
            url: '/api/teamsport/match/get',
            args: {
                division_id: $routeParams.divisionId
            },
            transform: teamsportutil.transformMatch,
            triggers: [{type: 'teamsportmatch', condition: function(match) { return !match.division_id || match.division_id == $routeParams.divisionId; } }],
            onItemsUpdated: function(items) {
                $scope.matchesConfig.twoTeams = !_.find(items, function(m) { return m.teams.length != 2; });
                $scope.matchesConfig.hasName = _.find(items, function(m) { return m.name; });
                $scope.matchesConfig.control.rebuild();
            }
        },
        tabs: [
            { name: 'Coming matches', badgeClass: 'badge-success', itemFilter: function(match) { return !match.finished; } },
            { name: 'Played matches', badgeClass: 'badge-warning', itemFilter: function(match) { return match.finished; } }
        ],
        countSuffixList: ['match', 'matches'],
        rowClick: $scope.showMatch,
        giveFocus: function() { return false; },
        searchDepth: 3,
        orderColumn: 'activity.startTime',
        columns: [
            {field: 'activity.startTime', title: 'Start time', format: 'datetimeshort'},
            {field: 'home_team', title: 'Home team', format: 'image', text: function(m) { return m.teams[0].name;}, src: function(m) { return teamsportutil.getImage(m.teams[0]); }, size: function() { return '50px'; }, visible: twoTeams },
            {field: 'away_team', title: 'Away team', format: 'image', text: function(m) { return m.teams[1].name;}, src: function(m) { return teamsportutil.getImage(m.teams[1]); }, size: function() { return '50px'; }, visible: twoTeams },
            {field: 'name', title: 'Name', visible: function() { return hasName(); } },
            {field: 'teams', title: 'Number of teams', format: 'count', visible: function() { return !twoTeams() && !($scope.division && $scope.division.competitionstep.gameclass.individual); } },
            {field: 'teams', title: 'Number of participants', format: 'count', visible: function() { return !twoTeams() && $scope.division && $scope.division.competitionstep.gameclass.individual; } },
            {field: 'location', title: 'Location', getValue: util.getRoomAndLocation, placeHolderUid: util.roomAndLocationPlaceHolderUid},
            {field: 'result', title: 'Result', getValue: getResult, visible: twoTeams },
            {field: 'round', title: 'Round'}
        ],
        searchButtons: [
            {title: 'Add match', onClick: $scope.addMatch, showOnEmpty: true}
        ],
        buttons: [
            { title: 'Set result', buttonClass: 'btn-success', visible: function(match) { return $rootScope.hasPermission('Competition handling') && !match.finished; }, onClick: $scope.setResult },
            { title: 'Change result', buttonClass: 'btn-warning', visible: function(match) { return $rootScope.hasPermission('Competition handling') && match.finished; }, onClick: $scope.setResult },
            { title: 'Change', buttonClass: 'btn-warning', visible: function(match) { return !match.finished && $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeMatch }
        ]
    };

    function fetchEventTypes() {
        server.get('/api/teamsport/eventtype/get').then(function(data) {
            $scope.eventtypes = data;
        });
    }
    fetchEventTypes();

    function readyToLoadTopLists() {
        return $scope.eventtypes && $scope.division;
    }

    function fetchTopLists() {
        server.get('/api/teamsport/toplist/for_division', {division_id: $routeParams.divisionId}).then(function(data) {
            $rootScope.waitFor(['members']).then(function() {
                var r = $scope.$watch(readyToLoadTopLists, function(value) {
                    if (value) {
                        createTopLists(data);
                        r();
                    }
                });
            });
        });
    }

    function fetchTable() {
        server.get('/api/teamsport/result/for_division', {division_id: $routeParams.divisionId}).then(function(data) {
            $rootScope.waitFor(['usergroups']).then(function() {
                $scope.matchtableconfig = teamsportutil.buildTable(data);
            });
        });
    }

    function fetchData() {
        fetchTopLists();
        fetchTable();
    }
    fetchData();

    function setOneMatchConfig() {
        if ($scope.division.competitionstep.gameclass.one_match && $scope.division.matches.length == 1) {
            $scope.oneMatchConfig = {
                match_id: $scope.division.matches[0]
            };
        }
    }

    function fetchDivision() {
        server.get('/api/teamsport/division/get', {id: $routeParams.divisionId}).then(function(data) {
            $scope.division = data;
            createTeamsConfig();
            setOneMatchConfig();
        });
    }
    fetchDivision();

    live.subscribe( {
        type: 'teamsportdivision',
        scope: $scope,
        callback: function(d) {
            if (d.id == $routeParams.divisionId) {
                fetchDivision();
            }
        }
    });

    live.subscribe( {
        type: 'teamsportmatch',
        scope: $scope,
        callback: function(m) {
            if (m.division_id == $routeParams.divisionId) {
                fetchData();
            }
        }
    });

    live.subscribe( {
        type: 'teamsportevent',
        scope: $scope,
        callback: function(teamsportevent) {
            if (teamsportevent.match.division_id == $routeParams.divisionId) {
                fetchData();
            }
        }
    });

    live.subscribe( {
        type: 'teamsportcompetition',
        scope: $scope,
        callback: function(competition) {
            if ($scope.division && $scope.division.competitionstep.gameclass.competition_id == competition.id) {
                fetchDivision();
            }
        }
    });

    live.subscribe( {
        type: 'teamsporttable',
        scope: $scope,
        callback: function(table) {
            if ($scope.division && $scope.division.competitionstep.gameclass.table_id == table.id) {
                fetchTable();
            }
        }
    });

    live.subscribe( {
        type: 'teamsporttoplist',
        scope: $scope,
        callback: fetchTopLists
    });

    live.subscribe( {
        type: 'payment',
        scope: $scope,
        callback: function() {
            getPaymentStatus();
        }
    });
}]);

teamsports.controller('TeamSportsOverviewCtrl', ['$rootScope', '$scope', '$location', '$modal', 'teamsportutil', 'server', 'util', function($rootScope, $scope, $location, $modal, teamsportutil, server, util) {
    $scope.loadingStatus = {loading: true};

    $scope.moveMatch = function(match) {
        $modal.open({
            templateUrl: 'views/teamsportmovematchmodal.html',
            windowClass: 'huge-modal-window',
            controller: 'TeamSportMoveMatchModalCtrl',
            resolve: {
                match: function() {
                    return server.get('/api/teamsport/match/get', {id: match.id}).then(function(m) {
                        return teamsportutil.transformMatch(m);
                    });
                },
                options: function() {
                    return {
                        matches: $scope.matchesConfig.control.getFilteredItems()
                    }
                }
            }
        });
    };

    $scope.showMatch = function(match) {
        $location.path('/teamsports/match/' + match.id);
    };

    var twoTeams = function() {
        return $scope.matchesConfig.twoTeams;
    };

    var hasName = function() {
        return $scope.matchesConfig.hasName;
    };

    var resulttypes = [{id: 'true', name: 'Yes'}, {id: 'false', name: 'No'}];
    var sports = [];

    server.get('/api/teamsport/get').then(function(result) {
        sports = result;
    });

    function hasTeamSport() {
        var t = _.findWhere($scope.matchesConfig.filter, {name: 'teamsports'});
        return t && t.value && t.value.length;
    }

    function getFromDate() {
        var fromDate = _.findWhere($scope.matchesConfig.filter, {name: 'fromDate'}).value;
        return fromDate && fromDate.yyyymmdd();
    }

    function getToDate() {
        var toDate = _.findWhere($scope.matchesConfig.filter, {name: 'toDate'}).value;
        return toDate && toDate.yyyymmdd();
    }


    function setReferee(match_id, referees) {
        var selected = referees;
        $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            windowClass: 'huge-modal-window',
            controller: 'GetCustomerCtrl',
            resolve: {
                options: function() {
                    return {
                        multiple: true,
                        selected: selected
                     };
                }
            }
        }).result.then(function(customers) {
            server.post('/api/teamsport/match/setreferee', null, {id: match_id, referee_id: _.pluck(customers, 'id')},
                'Information saved', 'Failed to save information').then(function() {
                    $scope.contacts = null;
                });
        });
    }

    function getRefereesNames(referees) {
        var r = "";
        for (var i = 0; i < referees.length; i++) {
            r += util.escapeHtml(referees[i].name) + "<br/>";
        }
        return r;
    }

    var gameclasses = [];
    function getGameclasses() {
        $scope.loadingStatus.loading = true;
        gameclasses = [];
        var g = _.findWhere($scope.matchesConfig.filter, {name: 'gameclasses'});
        g.value = null;
        if (g && g.visible()) {
            var t = _.findWhere($scope.matchesConfig.filter, {name: 'teamsports'});
            t = t.getValue(t);
            server.get('/api/teamsport/gameclass/name/get_for_sports', {teamsports: t, fromDate: getFromDate(), toDate: getToDate()}).then(function(result) {
                gameclasses = result;
            });
        }
    }

    function hasGameclass() {
        var g = _.findWhere($scope.matchesConfig.filter, {name: 'gameclasses'});
        return g && g.value && g.value.length;
    }

    var divisions = [];
    function getDivisions() {
        $scope.loadingStatus.loading = true;
        divisions = [];
        var d = _.findWhere($scope.matchesConfig.filter, {name: 'divisions'});
        d.value = null;
        if (d && d.visible()) {
            var g = _.findWhere($scope.matchesConfig.filter, {name: 'gameclasses'});
            g = g.getValue(g);
            server.get('/api/teamsport/division/name/get_for_gameclasses', {gameclasses: g, fromDate: getFromDate(), toDate: getToDate()}).then(function(result) {
                divisions = result;
            });
        }
    }

    function isRoomOrLocation(r) {
        return r.resourceType == 'room' || r.resourceType == 'location';
    }

    var date = new Date();
    var usergroupsMap = null;
    var startToDate = new Date();
    startToDate.setDate(date.getDate() + 60);
    $rootScope.waitFor(['members', 'usergroups']).then(function() {
        $scope.matchesConfig = {
            filter: [
                { name: 'fromDate', title: 'From', required: false, type: 'date', value: Date.today(), change: getGameclasses },
                { name: 'toDate', title: 'To', required: false, type: 'date', value: startToDate, change: getGameclasses },
                { name: 'finished', title: 'Result', required: false, type: 'select',  options: function() { return resulttypes; }, placeholder: 'Show all', useId: true },
                { name: 'referees', title: 'Referee', required: false, type: 'select',  options: function() { return resulttypes; }, placeholder: 'Show all', useId: true },
                { name: 'resources', title: 'Rooms and locations', required: false, type: 'multiselect', options: $rootScope.getActiveResources, placeholder: 'Show all', useId: true, getValue: function(f) { return _.pluck(f.value, 'id').join(','); }, optionsFilter: isRoomOrLocation },
                { name: 'teamsports', title: 'Sport', required: false, type: 'multiselect', options: function() { return sports;}, useId: true, placeholder: 'Show all', getValue: function(f) { return _.pluck(f.value, 'id').join(','); }, change: getGameclasses },
                { name: 'gameclasses', title: 'Game class', required: false, type: 'multiselect', options: function() { return gameclasses;}, placeholder: 'Show all', getValue: function(f) { return _.pluck(f.value, 'name').join(','); }, visible: hasTeamSport, change: getDivisions },
                { name: 'divisions', title: 'Division', required: false, type: 'multiselect', options: function() { return divisions;}, placeholder: 'Show all', getValue: function(f) { return _.pluck(f.value, 'name').join(','); }, visible: hasGameclass }
            ],
            api: {
                url: '/api/teamsport/match/overview',
                transform: function(m) {
                    m.startTime = Date.newFull(m.startTime);
                    m.endTime = Date.newFull(m.endTime);
                    m.resources = m.resources.map($rootScope.getMember);
                    if(!usergroupsMap) {
                        usergroupsMap = {};
                        $rootScope.usergroups.forEach(function(ug) {usergroupsMap[ug.id] = ug;});
                    }
                    m.teams.forEach(function(team) {
                        team.group = usergroupsMap[team.group_id];
                    });
                    if(m.compact) {
                        m.referees = m.referees.map($rootScope.getMember);
                    }
                    return m;
                },
                triggers: [{type: 'teamsportmatch'}],
                onItemsUpdated: function(items) {
                    $scope.matchesConfig.twoTeams = !_.find(items, function(m) { return m.teams.length != 2; });
                    $scope.matchesConfig.hasName = _.find(items, function(m) { return m.name; });
                    $scope.matchesConfig.control.rebuild();
                    $scope.loadingStatus.loading = false;
                    usergroupsMap = null;
                }
            },
            countSuffixList: ['match', 'matches'],
            rowClick: $scope.showMatch,
            giveFocus: function() { return false; },
            searchDepth: 3,
            orderColumn: 'startTime',
            columns: [
                { field: 'startTime', title: 'Start time', format: 'datetimeshort' },
                { field: 'resources', title: 'Rooms and locations', format: 'commaList' },
                { field: 'home_team', title: 'Home team', format: 'image', text: function(m) { return m.teams[0].name; }, src: function(m) { return teamsportutil.getImage(m.teams[0]); }, size: function() { return '50px'; }, visible: twoTeams },
                { field: 'away_team', title: 'Away team', format: 'image', text: function(m) { return m.teams[1].name; }, src: function(m) { return teamsportutil.getImage(m.teams[1]); }, size: function() { return '50px'; }, visible: twoTeams },
                { field: 'name', title: 'Name', visible: function() { return hasName(); }, getValue: teamsportutil.getMatchName },
                { field: 'referees', title: 'Referee', getValue: function(m) { return getRefereesNames(m.referees); }, showHtml: true },
                { field: 'teams', title: 'Number of teams', format: 'count', visible: function() { return !twoTeams(); } },
            ],
            buttons: [
                { title: 'Show', buttonClass: 'btn-success', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.showMatch },
                { title: 'Move', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.moveMatch },
                { title: 'Referee', buttonClass: 'btn-info', visible: function(m) { return $rootScope.hasPermission('Competition handling') && m.referees.length; }, onClick: function (m) { setReferee(m.id, m.referees); } },
                { title: 'Referee', buttonClass: 'btn-danger', visible: function(m) { return $rootScope.hasPermission('Competition handling') && !m.referees.length; }, onClick: function(m) { setReferee(m.id, []); } }
            ]
        };
    });
}]);

teamsports.controller('TeamSportMoveMatchModalCtrl', ['$rootScope', '$scope', '$filter', '$modal', '$q', 'server', 'teamsportutil', 'calendar', 'match', 'confirm', 'options',
    function($rootScope, $scope, $filter, $modal, $q, server, teamsportutil, calendar, match, confirm, options) {

    $scope.match = match;
    $scope.availableMatchTimes = [];
    $scope.existingMatches = [];
    $scope.all = { all: true, name: $filter('translate')('All'), active: true };
    $scope.resources = [ $scope.all ];
    $scope.selectedResource = $scope.all;
    $scope.endDate = Date.today();
    $scope.occupiedColor = '#ccc';

    $scope.titleSuffix = function() {
        return teamsportutil.getMatchName($scope.match);
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarSources = [[], []];
    calendar.updateTranslation([$scope.calendarConfig]);

    $scope.calendarObject = null;
    $scope.$watch(function() { return $scope.calendarObject; }, function() {
        if ($scope.calendarObject && $scope.calendarObject.fullCalendar) {
            $scope.calendarObject.fullCalendar('gotoDate', $scope.match.activity.startTime);
        }
    });

    var isSelectedResource = function(slot) {
        if ($scope.selectedResource.all) { return true; }
        return _.findWhere(slot.allresources, { id: $scope.selectedResource.id });
    };

    var getMatchesByStartEnd = function(startTime, endTime) {
        return _.filter($scope.existingMatches, function(match) {
            var matchStart = match.start.getTime();
            return startTime <= matchStart && matchStart <= endTime;
        });
    };

    var occupySlot = function(slot) {
        if (slot) {
            slot.backgroundColor = $scope.occupiedColor;
            slot.isOccupied = true;
        }
    };

    $scope.updateSchedule = function() {
        $scope.calendarSources[0] = $scope.availableMatchTimes.filter(isSelectedResource);
        $scope.calendarSources[1] = $scope.existingMatches.filter(isSelectedResource);
        calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);
    };

    var addUniqueResource = function(resources) {
        angular.forEach(resources, function(r) {
            if (!_.findWhere($scope.resources, { id: r.id })) {
                $scope.resources.push($rootScope.transformMember(r));
            }
        });
    };

    var buildSlot = function(startTime, endTime, resources) {
        return {
            start: Date.newFull(startTime),
            end: Date.newFull(endTime),
            backgroundColor: $scope.match.activity.workoutType.color,
            title: '',
            allresources: resources,
        };
    };

    var createSlotAroundMatches = function(slot, matches) {
        if (!matches.length) { return; }
        var minEnd = _.min(matches, function(match) { return match.end; }).end;
        var maxStart = _.max(matches, function(match) { return match.start; }).start;

        if (minEnd.getTime() !== slot.end.getTime()) {
            $scope.availableMatchTimes.push(buildSlot(minEnd, slot.end, slot.allresources));
        }

        if (maxStart.getTime() !== slot.start.getTime()) {
            $scope.availableMatchTimes.push(buildSlot(slot.start, maxStart, slot.allresources));
        }
    };

    var resourcesInUse = function(matches) {
        return _.uniq(_.map(matches, function(m) { return m.allresources[0]; }), 'id').length;
    };

    var parseMatchTime = function(matchTime) {
        var weekMultiplier = matchTime.interval || 1;

        var resources = _.map(matchTime.resources, $rootScope.getStaff);
        addUniqueResource(resources);

        var nextDate = $scope.startDate.getNextWeekDayOfType(matchTime.weekday);
        var timeParts = matchTime.from.split(':');
        nextDate.setHours(timeParts[0]);
        nextDate.setMinutes(timeParts[1]);

        var nextDateEnd = nextDate.clone();
        var timePartsEnd = matchTime.to.split(':');
        nextDateEnd.setHours(timePartsEnd[0]);
        nextDateEnd.setMinutes(timePartsEnd[1]);

        while (nextDate && $scope.endDate && nextDate < $scope.endDate) {
            if (!nextDate.isPastDate()) {
                var newSlot = buildSlot(nextDate, nextDateEnd, resources);
                var matches = getMatchesByStartEnd(nextDate, nextDateEnd);
                if (matches.length && resourcesInUse(matches) === resources.length) {
                    createSlotAroundMatches(newSlot, matches);
                } else {
                    $scope.availableMatchTimes.push(newSlot);
                }
            }

            nextDate = nextDate.clone();
            nextDateEnd = nextDateEnd.clone();
            nextDate.addDays(7 * weekMultiplier);
            nextDateEnd.addDays(7 * weekMultiplier);
        }
    };

    var getExistingMatches = function() {
        if(options?.matches) {
            options.matches.forEach(m => {
                var calSlot = buildSlot(m.startTime, m.endTime, m.resources);
                calSlot.id = m.id;
                calSlot.title = teamsportutil.getMatchName(m);
                calSlot.name = calSlot.title;
                occupySlot(calSlot);
                $scope.existingMatches.push(calSlot);
            });
            return Promise.resolve();
        }

        var deferred = $q.defer();

        var transformMatchSlot = function(slot) {
            slot.startTime = Date.newFull(slot.startTime);
            slot.endTime = Date.newFull(slot.endTime);
            if (slot.resources) {
                for (var i=0; i < slot.resources.length; ++i) {
                    slot.resources[i] = $rootScope.getMember(slot.resources[i]);
                }
            }
            return slot;
        };

        server.get('/api/teamsport/match/movematch/slots/get', { competition_id: $scope.match.competition_id }).then(function(matchSlots) {
            angular.forEach(matchSlots, function(slot) {
                var slot = transformMatchSlot(slot);
                var calSlot = buildSlot(slot.startTime, slot.endTime, slot.resources);
                calSlot.id = slot.id;
                calSlot.title = teamsportutil.getMatchName(slot);
                calSlot.name = calSlot.title;
                occupySlot(calSlot);
                $scope.existingMatches.push(calSlot);
            });
            deferred.resolve();
        });
        return deferred.promise;
    };

    var getMatchTimes = function() {
        getExistingMatches().then(function() {
            server.get('/api/teamsport/division/get', { id: $scope.match.division_id}).then(function(division) {
                if (!division || !division.competitionstep.gameclass) { return; }
                var gc = division.competitionstep.gameclass;
                $scope.startDate = Date.newFull(gc.competition.startDate);
                $scope.endDate = Date.newFull(gc.competition.endDate);
                $scope.match_length = gc.match_length;
                var matchTimes = division.groupplay_match_times;
                angular.forEach(matchTimes, parseMatchTime);
                $scope.updateSchedule();
            });
        });
    };
    getMatchTimes();

    var swap = function(calEvent) {
        var conflictingMatch = _.find($scope.existingMatches, function(match) {
            return match.start == calEvent.start && _.findWhere(match.allresources, { id: calEvent.allresources[0].id });
        });

        var message = $filter('translate')('Do you want to swap match "{0}" with "{1}"?').format(teamsportutil.getMatchName($scope.match), teamsportutil.getMatchName(conflictingMatch));
        confirm.show(message, { ladda: true }).then(function(resolve) {
            var data = { match1: $scope.match.id, match2: conflictingMatch.id };
            server.post('/api/teamsport/match/swap', data, null, 'Success', 'Fail').then(function(response) {
                if(response.success && response.data.affected_users?.length) {
                    $modal.open({
                        templateUrl: 'views/message.html',
                        controller: 'MatchSendMessageCtrl',
                        resolve: {
                            users: function() {
                                return response.data.affected_users;
                            }
                        }
                    });
                }
                $scope.$close();
                resolve();
            });
        });
    };

    var rebook = function(calEvent) {
        var resources = calEvent.allresources;

        var options = { startTime: calEvent.start, endTime: calEvent.end, match_length: $scope.match_length, resources: resources, bookings: $scope.existingMatches };
        if ($scope.selectedResource && !$scope.selectedResource.all) {
            options.selectedResource = $scope.selectedResource;
        }
        var modalInstance = $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamSportMatchRebookCtrl',
            resolve: {
                match: function() {
                    return $scope.match;
                },
                options: function() {
                    return options;
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.$close();
        });
    };

    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isOccupied) {
            swap(calEvent);
        } else {
            rebook(calEvent);
        }
    };

}]);

teamsports.controller('MatchSendMessageCtrl', ['$scope', 'server', '$rootScope', '$filter', 'users', function($scope, server, $rootScope, $filter, users) {
    $scope.title = 'Send message';
    $scope.loadingStatus = {};

    var peopleWithMail = [];
    var peopleWithPhone = [];

    function isSms() {
        return _.findWhere($scope.fields, {name: 'sms'}).value;
    }

    function isMail() {
        return !isSms();
    }

    $scope.submit = function() {
        let people = _.findWhere($scope.fields, {name: 'recipients'}).value;
        if (isSms()) {
            var message = _.findWhere($scope.fields, {name: 'message_sms'}).value;
            var recipients = [];
            angular.forEach(people, function(item) {
                var r = { phone: item.phone };
                if (item.isMember) {
                    r.member_id = item.id;
                } else {
                    r.staff_id = item.id;
                }
                recipients.push(r);
            });
            server.post('/api/sms/send', {recipients: recipients, text: message}, null, 'SMS sent', 'Failed to send SMS').then(function(result) {
                if (result.success) {
                    $scope.$close();
                } else {
                    $scope.loadingStatus.loading = false;
                }
            });
        } else {
            var members = _.pluck(people.filter(function(item) { return item.isMember; }), 'id');
            var staffs = _.pluck(people.filter(function(item) { return !item.isMember; }), 'id');
            var others = [];

            var message = _.findWhere($scope.fields, {name: 'message_mail'}).value;
            var from = _.findWhere($scope.fields, {name: 'from'}).value;
            var subject = _.findWhere($scope.fields, {name: 'subject'}).value;
            var replyTo = _.findWhere($scope.fields, {name: 'replyTo'}).value;
            var mail = {members: members, staffs: staffs, others: others, message: message, from: from, subject: subject, replyTo: replyTo};

            server.post('/api/mail/send', mail, null, 'Mail sent', 'Failed to send mail').then(function(result) {
                if (result.success) {
                    $scope.$close();
                } else {
                    $scope.loadingStatus.loading = false;
                }
            });
        }
    };

    $scope.getRecipientsValue = function() {
        var sms = _.findWhere($scope.fields, {name: 'sms'});
        if (!sms) {
            return;
        }
        return sms.value ? peopleWithPhone : peopleWithMail;
    };

    $scope.sendDisabled = function() {
        return peopleWithMail.length == 0;
    };

    server.get('/api/settings/get').then(function(settings) {
        if (settings.mail) {
            var field = _.findWhere($scope.fields, {name: 'replyTo'});
            if (!field.value) {
                field.value = settings.mail;
            }
        }
    });

    $scope.getTitle = function(name) {
        if (name) {
            return _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)}).title;
        }
    };

    function smsChange() {
        _.findWhere($scope.fields, {name: 'recipients'}).value = $scope.getRecipientsValue();
    }

    function setSendList() {
        $rootScope.getMembersAsync(users).then((members) => {
            peopleWithMail = _.filter(members, function(item) { return item.mail && item.mail.length > 0; });
            peopleWithPhone = _.filter(members, function(item) { return item.phone && item.phone.length > 0; });
            smsChange();
        });
    }

    $scope.fields = [
        {name: 'sms', title: 'SMS', required: true, type: 'checkbox', value: false, change: smsChange, visible: function() { return $rootScope.hasPermission('Send SMS'); } },
        {name: 'recipients', title: 'Recipients', type: 'customers', required: true, useId: true },
        {name: 'from', title: 'From', required: true, type: 'text', visible: isMail },
        {name: 'replyTo', title: 'Reply to address', required: true, type: 'email', visible: isMail },
        {name: 'subject', title: 'Subject', required: true, type: 'text', visible: isMail },
        {name: 'message_mail', title: 'Message', required: true, type: 'htmleditor', visible: isMail },
        {name: 'message_sms', title: 'Message', required: true, type: 'textarea', visible: isSms }
    ];

    _.findWhere($scope.fields, {name: 'from'}).value = $rootScope.currentStaff.firstname + ' ' + $rootScope.currentStaff.lastname;
    setSendList();
}]);

teamsports.controller('TeamSportMatchRebookCtrl', ['$scope', '$controller', 'server', 'match', 'options', function($scope, $controller, server, match, options) {
    $controller('ChangeModalCtrl', { $scope: $scope });

    $scope.match = match;
    $scope.startTime = options.startTime || null;
    $scope.endTime = options.endTime || null;
    $scope.match_length = options.match_length || null;
    $scope.resources = options.resources || [];
    $scope.selectedResource = options.selectedResource || null;
    $scope.bookings = options.bookings || null;

    $scope.item = {
        day: $scope.startTime,
        startTime: $scope.startTime,
        resource: $scope.selectedResource,
    };
    $scope.availableResources = options.resources || [];

    $scope.postUrl = '/api/teamsport/match/move';

    $scope.titleSuffix = function() {
        return 'match';
    };

    var isReadOnly = function() {
        return $scope.startTime != null;
    };

    var updateResources = function() {
        if (!$scope.bookings) { return; }

        var day = _.findWhere($scope.fields, { name: 'day' }).value;
        var time = _.findWhere($scope.fields, { name: 'startTime' }).value;

        var timeParts = time.hhmm().split(':');
        var matchDatetime = day.clone();
        matchDatetime.setHours(timeParts[0], timeParts[1]);
        var matchDatetimeEnd = matchDatetime.clone().addMinutes($scope.match_length);
        var overlappingBookings = _.filter($scope.bookings, function(booking) {
            if (!day.isSameDateAs(booking.start)) { return false; }
            return (matchDatetime.hhmm() < booking.end.hhmm()) && (matchDatetimeEnd.hhmm() > booking.start.hhmm());
        });

        $scope.availableResources = _.filter($scope.resources, function(resource) {
            return !_.find(overlappingBookings, function(booking) {
                return _.findWhere(booking.allresources, { id: resource.id });
            });
        });
        var field = _.findWhere($scope.fields, { name: 'resource' });
        field.value = _.findWhere($scope.availableResources, { id: field.value && field.value.id }) || $scope.availableResources[0];
    };

    var setResourceValue = function(field) {
        if ($scope.selectedResource) {
            return $scope.selectedResource;
        }
        var options = field.options();
        if (options.length === 1) { return options[0]; }
        var resource = $scope.match.activity.resources[0];
        return _.findWhere(options, { id: resource.id });
    };

    $scope.fields = [
        { name: 'day', title: 'Day', type: 'date', required: true, readonly: isReadOnly() },
        { name: 'startTime', title: 'Start time', type: 'time', required: true, change: updateResources },
        { name: 'resource', title: 'Rooms and locations', type: 'select', required: true, options: function() { return $scope.availableResources; }, setValue: setResourceValue },
    ];

    $scope.canSubmit = function() {
        for (var i = 0; i < $scope.fields.length; i++) {
            var field = $scope.fields[i];
            if (!field || !field.value) {
                return false;
            }
        }
        return true;
    };

    var oldValuesChanged = $scope.valuesChanged;
    $scope.valuesChanged = function() {
        if ($scope.selectedResource) {
            return true;
        }
        return oldValuesChanged();
    };

    var oldDoSubmit = $scope.doSubmit;
    $scope.doSubmit = function(item) {
        item.id = $scope.match.id;
        var hhmmParts = item.startTime.split(':');
        item.startTime = $scope.startTime.clone();
        item.startTime.setHours(hhmmParts[0], hhmmParts[1]);
        item.startTime = item.startTime.dateTime();
        if ($scope.match_length) {
            item.endTime = Date.newFull(item.startTime);
            item.endTime = item.endTime.addMinutes($scope.match_length).dateTime();
        } else {
            item.endTime = $scope.endTime && $scope.endTime.dateTime();
        }
        oldDoSubmit(item);
    };

    $scope.setValues($scope.item);
    updateResources();
}]);

teamsports.controller('MatchModalCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'teamsportutil', 'workoutProvider', 'confirm', 'server', 'live', 'match',
    function($rootScope, $scope, $modal, $filter, teamsportutil, workoutProvider, confirm, server, live, match) {

    $scope.match = match;

    $scope.getTeamTitle = function() {
        return teamsportutil.getMatchName($scope.match);
    };

    $scope.getDateTitle = function() {
        var activity = $scope.match.activity;
        return activity.startTime.yyyymmdd() + ", " + activity.startTime.hhmm() + " - " + activity.endTime.hhmm();
    };

    $scope.getResources = function() {
        return $scope.match.activity.resources;
    };

    $scope.getTeamName = function(teamIndex) {
        return $scope.match.teams[teamIndex].name;
    };

    $scope.closeAndGotoResource = function(resource) {
        $scope.$close();
        $rootScope.gotoStaff(resource);
    };

    $scope.showActivity = function(id) {
        workoutProvider.getWorkoutById(id).then(function(w) {
            $rootScope.showWorkout(w);
        });
    };

    $scope.moveMatch = function() {
        $modal.open({
            templateUrl: 'views/teamsportmovematchmodal.html',
            windowClass: 'huge-modal-window',
            controller: 'TeamSportMoveMatchModalCtrl',
            resolve: {
                match: function() {
                    return $scope.match;
                }
            }
        });
    };

    $scope.setResult = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'TeamMatchSetResultCtrl',
            resolve: {
                match: function() {
                    return $scope.match;
                }
            }
        });

        modalInstance.result.then(function() {
            $scope.$close();
        });
    };

    $scope.remove = function() {
        confirm.show($filter('translate')('Are you sure you want to remove {0}').format($scope.getTeamTitle())).then(function() {
            server.post('/api/teamsport/match/remove', null, { id: $scope.match.id }, 'Match removed', 'Failed to remove match');
        });
    };

    live.subscribe( {
        type: 'teamsportmatch',
        scope: $scope,
        callback: function(match) {
            if ($scope.match && match.id == $scope.match.id) {
                // Update activity
                var activity = $rootScope.transformWorkout(match.activity);
                $scope.match.activity.startTime = activity.startTime;
                $scope.match.activity.endTime = activity.endTime;
                $scope.match.activity.resources = activity.resources;

                // Update match
                var props = ['finished', 'result', 'referees_id', 'teams'];
                props.forEach(function(p) {
                    $scope.match[p] = match[p];
                });
                $scope.match.referees = teamsportutil.transformMatch(match).referees;
            }
        }
    });

}]);

teamsports.controller('TeamSportGeneralSettingsCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/teamsport/settings/get';
    $scope.postUrl = '/api/teamsport/settings/set';

    var referee_types = [
        {id: 'nothing', name: 'Can not report anything'},
        {id: 'both', name: 'Can report both results and events'},
        {id: 'result', name: 'Can report results'},
        {id: 'event', name: 'Can report events'},
    ];

    var teamleader_types = [
        {id: 'nothing', name: 'Can not report anything'},
        {id: 'both', name: 'Can report both results and events'},
        {id: 'both_team', name: 'Can report both results and events for own team'},
        {id: 'event_team', name: 'Can report events for own team'},
        {id: 'result', name: 'Can report results'},
        {id: 'event', name: 'Can report events'},
    ];

    var substituteTypes = [
        { id: 'nothing', name: 'Do not offer' },
        { id: 'unique_in_series', name: 'Can not play in the same series'},
        { id: 'free_in_series', name: 'Can play in the same series'}
    ];

    $scope.fields = [
        { name: 'referee_report', title: 'Referee', type: 'select', options: function() { return referee_types; }, required: true, useId: true },
        { name: 'teamleader_report', title: 'Team leader', type: 'select', options: function() { return teamleader_types; }, required: true, useId: true },
        { name: 'result_report_days', title: 'Possible to report results', type: 'infoNumber', info: 'days' },
        { name: 'event_report_days', title: 'Possible to report events', type: 'infoNumber', info: 'days' },
        { name: 'live_report', title: 'Live reporting', type: 'checkbox' },
        { name: 'substitute_type', title: 'Substitute', type: 'select', options: function() { return substituteTypes; }, required: true, useId: true, visible: function() { return $rootScope.hasModule('PlayerPool'); } }
    ];

    $scope.getSettings();
}]);

teamsports.controller('CompetitionStepCtrl', ['$rootScope', '$scope', '$location', '$routeParams', 'server', 'confirm', 'util', function($rootScope, $scope, $location, $routeParams, server, confirm, util) {
    $scope.addDivision = function() {
        util.showDataDialog({controller: 'TeamSportDivisionDataCtrl', data: {competitionstep: $scope.competitionstep}});
    };

    $scope.changeDivision = function(division) {
        util.showDataDialog({controller: 'TeamSportDivisionDataCtrl', item: division});
    };

    $scope.removeDivision = function(division) {
        confirm.show('Are you sure you want to remove the division?', {ladda: true}).then(function(resolve) {
            server.post('/api/teamsport/division/remove', null, {id: division.id}, 'Division removed', 'Failed to remove division').then(resolve);
        });
    };

    $scope.divisionsConfig = {
        api: {
            url: '/api/teamsport/division/get',
            args: {
                competitionstep_id: $routeParams.stepId
            },
            triggers: [{type: 'teamsportdivision'}]
        },
        countSuffixList: ['division', 'divisions'],
        rowClick: function(d) {
            $location.path('/teamsports/division/' + d.id);
        },
        giveFocus: function() { return false; },
        orderColumn: 'name',
        columns: [
            {field: 'name', title: 'Name'}
        ],
        searchButtons: [
            {title: 'Add', onClick: $scope.addDivision, showOnEmpty: true, visible: function() {return true;} }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.changeDivision },
            { title: 'Set referee', buttonClass: 'btn-info', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.setReferee },
            { title: 'Remove', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Competition handling'); }, onClick: $scope.removeDivision }
        ]
    };

    function fetchCompetitionStep() {
        server.get('/api/teamsport/competitionstep/get', {id: $routeParams.stepId}).then(function(result) {
            $scope.competitionstep = result;
        });
    }

    fetchCompetitionStep();
}]);

teamsports.controller('AssignTimesCtrl', ['$rootScope', '$scope', '$filter', '$controller', 'server', 'teamsportutil', 'options', 'confirm', 'alertProvider', function($rootScope, $scope, $filter, $controller, server, teamsportutil, options, confirm, alertProvider) {
    var competition = options.competition;
    var division = options.division;

    $controller('AddCtrl', {$scope: $scope});
    $controller('TeamSportLeagueBaseSettingsCtrl', {$scope: $scope, competition: competition});

    $scope.postUrl = '/api/teamsport/times/assign';
    $scope.callCloseOnSuccess = true;
    $scope.title = 'Assign times';
    $scope.titleSuffix = function() {
        var name = options.competitionstep && options.competitionstep.name ||
            options.gameclass && options.gameclass.name ||
            division && division.name || competition.name;
        return $filter('translate')('for') + ' ' + name;
    };

    $scope.getLeagueSettingsFields = function() {
        return $scope.fields;
    };

    $scope.canSubmit = function() {
        var item = $scope.getLeagueSettingsSubmitItem();
        return item.groupplay_match_times.length > 0;
    };

    function getMatches() {
        if(!division) {return;}
        server.get('/api/teamsport/match/get', {division_id: division.id, full: false}).then(function(res) {
            res.forEach(function(match) {
                teamsportutil.transformMatch(match);
            });
            $scope.matches = res.filter(function(match) { return !match.activity; });
        });
    }
    getMatches();

    function onChangeMatchLength() {
        var match_length = _.findWhere($scope.fields, {name: 'match_length'}).value;
        _.findWhere($scope.fields, {name: 'collection_time'}).value = (match_length && match_length < 45)?45-match_length:0;
    }

    $scope.fields = [
        {name: 'match_length', title: 'Match length', type: 'infoNumber', info: 'minutes', required: true, change: onChangeMatchLength },
        {name: 'collection_time', title: 'Collection time', required: false, type: 'infoNumber', info: 'minutes', visible: function() { return $rootScope.hasModule('LOK'); } },
        {name: 'max_per_week', title: 'Max number of matches per team/week', type: 'infoNumber', info: 'meetings', required: false },
        {name: 'max_number_of_matches', title: 'Max number of matches per team/day', required: false, type: 'number' },
        {name: 'max_days_per_week', title: 'Max number of rounds per week', type: 'infoNumber', info: 'days', required: false },
        {name: 'groupplay_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('match time'), click: function() { $scope.addMatchTime(); } },
        {name: 'break_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('MATCH_BREAK'), click: function() { $scope.addBreak(); } }
    ];

    if(division) {
        $scope.fields.unshift({name: 'matches', title: 'Matches', type: 'multiselect', options: function() { return $scope.matches; }, getName: teamsportutil.getMatchName, placeholder: 'All', useId: true });
        $scope.fields.unshift({name: 'division_id', title: 'Division', type: 'select', readonly: true, value: division, options: function() { return [division]; }, useId: true});
    }

    function getSubmitItem() {
        var result = $scope.getSubmitItem();
        if(options.division) {
            result.division_id = options.division.id;
        } else if(options.competitionstep) {
            result.competitionstep_id = options.competitionstep.id;
        } else if(options.gameclass) {
            result.gameclass_id = options.gameclass.id;
        } else {
            result.competition_id = competition.id;
        }
        delete result.groupplay_matchtime;
        delete result.break;
        result.match_times = [];
        $scope.fields.forEach(function(f) {
            if(f.name != 'groupplay_matchtime') {return;}
            result.match_times.push(f.value);
        });
        result.breaks = [];
        $scope.fields.forEach(function(f) {
            if(f.name != 'break') {return;}
            result.breaks.push(f.value);
        });
        return result;
    }

    $scope.submit = function(force) {
        $scope.loadingStatus.loading = true;
        var data = getSubmitItem();
        if(force) {data.force = force;}
        server.post($scope.postUrl, data).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.possiblyClose(result.data);
                alertProvider.show('success', 'Item added');
            } else {
                if(result.data && result.data.type == 'data_error') {
                    var message = $filter('translate')('Only {0} matches of {1} will get times. Continue?')
                        .replace('{0}', result.data.args.num_assigned).replace('{1}', result.data.args.num_matches);
                    confirm.show(message).then(function() {
                        $scope.submit(true);
                    });
                } else {
                    alertProvider.show('error', 'Failed to add item');
                }
            }
        });
    };
}]);

teamsports.controller('TeamSportsSuspensionsListCtrl', ['$rootScope', '$scope', '$location', '$routeParams', '$modal', 'teamsportutil', 'server', function($rootScope, $scope, $location, $routeParams, $modal, teamsportutil, server) {
    $scope.loadingStatus = {loading: true};

    $scope.removeSuspension = (item) => {
        server.post('/api/teamsport/suspensions/remove', null, {user_id: item.user_id, workout_id: item.workout_id}, 'Suspension removed', 'Failed to remove suspension').then(() => {
            $scope.suspensionConfig.control.updateApi()
        })
    };

    $scope.addSuspension = () => {
        $modal.open({
            templateUrl: 'views/teamsportaddsuspension.html',
            controller: 'TeamSportAddSuspensionCtrl',
        });
    };

    $rootScope.waitFor(['members']).then(async () => {
        $scope.sports = await server.get('/api/teamsport/get');
        $scope.competitions = await server.get('/api/teamsport/competition/get');
        $scope.suspensionConfig = {
            filter: [
                { name: 'from_time', title: 'From', required: false, type: 'date', value: Date.today() },
                { name: 'to_time', title: 'To', required: false, type: 'date', value: null },
            ],
            api: {
                url: '/api/teamsport/suspensions/get',
                args: {match_id: $routeParams.matchId || null},
                triggers: [{type: 'teamsportsuspension'}],
                transform: (item, index) => {
                    item.id = index;
                    item.user = $rootScope.members.find((user) => user.id == item.user_id);
                    item.startTime = Date.newFull(item.match.activity.startTime);
                    item.competition = $scope.competitions.find((comp) => comp.id == item.match.competition_id );
                    item.sport = $scope.sports.find((sport) => sport.id == item.competition.teamsport_id );
                    return item;
                },
                onItemsUpdated: () => {
                    $scope.loadingStatus.loading = false;
                }
            },
            countSuffixList: ['Suspension', 'Suspensions'],
            hideSearchWhenFewerThan: 1,
            searchDepth: 3,
            rowClick: (item) => {
                if (!$routeParams.matchId) {
                    $location.path('/teamsports/match/' + item.match.id);
                }
            },
            giveFocus: () => false,
            orderColumn: '',
            columns: [
                { field: 'user.fullname', title: 'Name' },
                { field: 'team.name', title: 'Team name' },
                { field: 'sport.name', title: 'Sport' },
                { field: 'matchName', title: 'Match', getValue: (item) => teamsportutil.getMatchName(item.match) },
                { field: 'startTime', title: 'Start time', format: 'datetimeshort' },
            ],
            buttons: [
                { title: 'Remove', buttonClass: 'btn-danger', visible: () => $rootScope.hasPermission('Competition handling'), onClick: $scope.removeSuspension  }
            ],
            searchButtons: [
                { title: 'Add', buttonClass: 'btn-success', visible: () => $rootScope.hasPermission('Competition handling'), onClick: $scope.addSuspension, showOnEmpty: true}
            ]
        };
    });
}]);

teamsports.controller('TeamSportAddSuspensionCtrl', ['$rootScope', '$scope', 'server', 'teamsportutil', function($rootScope, $scope, server, teamsportutil) {
    $scope.submit = () => {
        server.post('/api/teamsport/suspensions/add', null, {
            user_id: $scope.fields.find((field) => field.name == 'user').value?.id,
            match_id: $scope.fields.find((field) => field.name == 'match').value?.id,
        }, 'Suspension added', 'Failed to add suspension').then(() => {
            $scope.$close();
        });
    }

    $scope.fetchSports = () => {
        server.get('/api/teamsport/get').then((res) => {
            $scope.sports = res;
            return res;
        })
    };
    $scope.fetchSports();

    $scope.fetchCompetitions = () => {
        server.get('/api/teamsport/competition/get', { teamsport_id: $scope.fields.find((field) => field.name == 'sport').value?.id }).then((res) => {
            $scope.competitions = res;
            return res;
        });
    };

    $scope.fetchGameclasses = () => {
        server.get('/api/teamsport/gameclass/get', {
            teamsport_id: $scope.fields.find((field) => field.name == 'sport').value?.id,
            competition_id: $scope.fields.find((field) => field.name == 'competition').value?.id,
        }).then((res) => {
            $scope.gameclasses = res;
            return res;
        });
    };

    $scope.fetchDivisions = () => {
        server.get('/api/teamsport/division/get', {
            gameclass_id: $scope.fields.find((field) => field.name == 'gameclass').value?.id,
        }).then((res) => {
            $scope.divisions = res;
            return res;
        });
    };

    $scope.fetchMatches = () => {
        server.get('/api/teamsport/match/get', {
            competition_id: $scope.fields.find((field) => field.name == 'competition').value?.id,
            gameclass_id: $scope.fields.find((field) => field.name == 'gameclass').value?.id,
            division_id: $scope.fields.find((field) => field.name == 'division').value?.id,
        }).then((res) => {
            const matchfield = $scope.fields.find((field) => field.name == 'match');
            matchfield.value = res.find((match) => match.id == matchfield.value?.id);
            $scope.matches = res.map((match) => {match.name = teamsportutil.getMatchName(match); return match});
            return res;
        });
    };

    var competitionChange = async () => {
        await $scope.fetchGameclasses();
        $scope.fetchMatches();
    };

    var gameclassChange = async () => {
        await $scope.fetchDivisions();
        $scope.fetchMatches();
    };

    $scope.fields = [
        { name: 'user', title: 'Member', type: 'customer', required: true },
        { name: 'sport', title: 'Sport', type: 'select', required: false, options: () => $scope.sports, change: () => {$scope.fetchCompetitions()} },
        { name: 'competition', title: 'Competition', visible: () => $scope.competitions, type: 'select', options: () => $scope.competitions, required: false, change: competitionChange },
        { name: 'gameclass', title: 'Game class', visible: () => $scope.gameclasses , type: 'select', options:() => $scope.gameclasses, required: false, change: gameclassChange },
        { name: 'division', title: 'Division', visible: () => $scope.divisions , type: 'select', options:() => $scope.divisions, required: false, change: $scope.fetchMatches },
        { name: 'match', title: 'Match', type: 'select', required: true, options: () => $scope.matches },
    ]
}]);
